
const startYear = 1974;
const currentYear = new Date().getFullYear();

const generatedYears = [];

for (let year = startYear; year <= currentYear; year++) {
    generatedYears.push({ id: year.toString() });
}

generatedYears.sort((a, b) => -a.id.localeCompare(b.id));

export const years = generatedYears;

export const repositories = [
    {
        "label": "National specific datasets",
        "id": 1,
    },
    {
        "label": "Agricultural census",
        "id": 2,
    },
    {
        "label": "Agricultural surveys",
        "id": 3
    },
]

export const countries = [
    {
        "label": "Afghanistan",
        "id": "004",
        "code": "AF",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": [
            {
                "categoryId": 2,
                "type": "PDF",
                "name": "State of Food and Agriculutre 2022",
                "url": "https://www.fao.org/4/a0800e/a0800e.pdf",
                "description": "State of Food and Agriculutre 2022 lorem ipsum description",
                "updated": "2022-03-05",
                "source": "FAO"
            },
            {
                "categoryId": 2,
                "type": "XLS",
                "name": "Food Price Index",
                "url": "https://www.fao.org/fileadmin/templates/worldfood/Reports_and_docs/food_price_index_nominal_real.xls",
                "description": "Comprehensive food price data for the year 2023",
                "updated": "2024-04-11",
                "source": "WFP"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "This is a google link",
                "url": "https://www.google.com",
                "description": "Link to the company homepage",
                "updated": "2024-05-22",
                "source": "World Bank"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "Second Link",
                "url": "https://example.com",
                "description": "Link to the homepage",
                "updated": "2024-08-20",
                "source": "World Bank"
            },
            {
                "categoryId": 3,
                "type": "PDF",
                "name": "Test PDF",
                "url": "https://example.com",
                "description": "Link to the PDF",
                "updated": "2024-08-21",
                "source": "FAO"
            }
        ]
    },
    {
        "label": "Albania",
        "id": "008",
        "code": "AL",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Algeria",
        "id": "012",
        "code": "DZ",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "American Samoa",
        "id": "016",
        "code": "AS",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Andorra",
        "id": "020",
        "code": "AD",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Angola",
        "id": "024",
        "code": "AO",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Antigua and Barbuda",
        "id": "028",
        "code": "AG",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Argentina",
        "id": "032",
        "code": "AR",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Armenia",
        "id": "051",
        "code": "AM",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Armenia AGRIS: Survey of Agricultural Holdings 2020",
                "href": "https://microdata.armstat.am/index.php/catalog/29"
            }
        ]
    },
    {
        "label": "Australia",
        "id": "036",
        "code": "AU",
        "countryCompareId": [
            "053",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Austria",
        "id": "040",
        "code": "AT",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Azerbaijan",
        "id": "031",
        "code": "AZ",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bahamas",
        "id": "044",
        "code": "BS",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bahrain",
        "id": "048",
        "code": "BH",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bangladesh",
        "id": "050",
        "code": "BD",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Barbados",
        "id": "052",
        "code": "BB",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Belarus",
        "id": "112",
        "code": "BY",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Belgium",
        "id": "056",
        "code": "BE",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Belize",
        "id": "084",
        "code": "BZ",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Benin",
        "id": "204",
        "code": "BJ",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bermuda",
        "id": "060",
        "code": "BM",
        "countryCompareId": [
            "021",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bhutan",
        "id": "064",
        "code": "BT",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bolivia (Plurinational State of)",
        "id": "068",
        "code": "BO",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bosnia and Herzegovina",
        "id": "070",
        "code": "BA",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Botswana",
        "id": "072",
        "code": "BW",
        "countryCompareId": [
            "018",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Brazil",
        "id": "076",
        "code": "BR",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": [
            {
                "categoryId": 1,
                "type": "PDF",
                "name": "State of Food and Agriculutre 2022",
                "url": "https://www.fao.org/4/a0800e/a0800e.pdf",
                "description": "The State of Food and Agriculture 2022 looks into the true cost of food for sustainable agrifood systems.",
                "updated": "2022-03-05",
                "source": "FAO"
            },
            {
                "categoryId": 1,
                "type": "XLS",
                "name": "Food Price Index",
                "url": "https://www.fao.org/fileadmin/templates/worldfood/Reports_and_docs/food_price_index_nominal_real.xls",
                "description": "Comprehensive food price data for the year 2023",
                "updated": "2024-04-11",
                "source": "FishStat"
            },
            {
                "categoryId": 1,
                "type": "XLS",
                "name": "Agricultural Integrated Survey - Microdata Files",
                "url": "https://www.google.com",
                "description": " The agricultural integrated survey is conducted to collect statistical information on the agriculture in Brazil.",
                "updated": "2024-05-22",
                "source": "World Bank"
            },
            {
                "categoryId": 1,
                "type": "PDF",
                "name": "Integrated Household Panel Survey",
                "url": "https://google.com",
                "description": "The Integrated Household Panel Survey (IHPS) was integrated into the core Integrated Household Survey (IHS) program to study trends in poverty, socioeconomic and agricultural characteristics over time through a longitudinal survey.",
                "updated": "2024-08-20",
                "source": "World Bank"
            },
            {
                "categoryId": 1,
                "type": "PDF",
                "name": "Impact of Pesticides on Human Health",
                "url": "https://example.com",
                "description": "The Brazilian population has been exposed to pesticides used in the production of commodities directly through dermal, oral, eye perfusion.",
                "updated": "2024-08-21",
                "source": "FAO"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "Food consumption markers in Brazil",
                "url": "https://example.com",
                "description": "Healthy food consumption markers included: consuming beans, fruits, and vegetables at least five days a week...",
                "updated": "2024-08-21",
                "source": "FAO"
            },
            {
                "categoryId": 2,
                "type": "link",
                "name": "Undernourishment Statistics",
                "url": "https://www.fao.org/fileadmin/templates/worldfood/Reports_and_docs/food_price_index_nominal_real.xls",
                "description": "Data on undernourishment are from the Food and Agriculture Organization (FAO) of the United Nations and measure food deprivation based on average food available",
                "updated": "2024-04-11",
                "source": "FAO"
            },
            {
                "categoryId": 2,
                "type": "link",
                "name": "Brazil Microdata Files",
                "url": "https://www.google.com",
                "description": " The agricultural integrated survey is conducted to collect statistical information on the agriculture in Brazil.",
                "updated": "2024-05-22",
                "source": "FAO"
            },
            {
                "categoryId": 2,
                "type": "link",
                "name": "Household Panel Survey",
                "url": "https://google.com",
                "description": "The Integrated Household Panel Survey (IHPS) was integrated into the core Integrated Household Survey (IHS) program to study trends in poverty, socioeconomic and agricultural characteristics over time through a longitudinal survey.",
                "updated": "2024-08-20",
                "source": "World Bank"
            },
            {
                "categoryId": 2,
                "type": "PDF",
                "name": "Impact of Disasters in Agrifod Systems",
                "url": "https://example.com",
                "description": "The Brazilian population has been exposed to pesticides used in the production of commodities directly through dermal, oral, eye perfusion.",
                "updated": "2024-08-21",
                "source": "FAO"
            }
        ]
    },
    {
        "label": "Brunei Darussalam",
        "id": "096",
        "code": "BN",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Bulgaria",
        "id": "100",
        "code": "BG",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Burkina Faso",
        "id": "854",
        "code": "BF",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Burundi",
        "id": "108",
        "code": "BI",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Cabo Verde",
        "id": "132",
        "code": "CV",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Cambodia",
        "id": "116",
        "code": "KH",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Cambodia Agricultural Survey 2021 Survey Report",
                "href": "https://www.nis.gov.kh/index.php/km/2-uncategorised/141-cambodia-agriculture-survey-2021"
            },
            {
                "label": "Cambodia Agricultural Survey 2021 Statistical Brief",
                "href": "https://www.nis.gov.kh/nis/CAS23/CAS%202021%20-%20Statistical%20Brief%20-%20ENG.pdf"
            },
            {
                "label": "Cambodia Agricultural Survey 2021 Microdata Files",
                "href": "https://microdata.nis.gov.kh/index.php/catalog/44"
            },
            {
                "label": "Cambodia Agricultural Survey 2020 Survey Report",
                "href": "https://www.nis.gov.kh/index.php/km/31-cas/110-cas2020"
            },
            {
                "label": "Cambodia Agricultural Survey 2020 Statistical Brief",
                "href": "https://www.nis.gov.kh/nis/Agriculture/CAS2020/Statistical Release CAS 2020_EN.pdf"
            },
            {
                "label": "Cambodia Agricultural Survey 2020 Microdata Files",
                "href": "https://microdata.nis.gov.kh/index.php/catalog/38"
            },
            {
                "label": "Cambodia Inter-Censual Agricultural Survey 2019 Survey Report",
                "href": "https://www.nis.gov.kh/nis/Agriculture/CIAS2019/CIAS%202019%20report_FINAL_EN.pdf"
            },
            {
                "label": "Cambodia Inter-Censual Agricultural Survey 2019 Statistical Brief",
                "href": "https://www.nis.gov.kh/nis/Agriculture/CIAS2019/Statistical%20Release%20CIAS%202019_Final_EN.pdf"
            },
            {
                "label": "Cambodia Inter-Censual Agricultural Survey 2019 Microdata Files",
                "href": "https://microdata.nis.gov.kh/index.php/catalog/36"
            }
        ]
    },
    {
        "label": "Cameroon",
        "id": "120",
        "code": "CM",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Canada",
        "id": "124",
        "code": "CA",
        "countryCompareId": [
            "021",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Central African Republic",
        "id": "140",
        "code": "CF",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Chad",
        "id": "148",
        "code": "TD",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Chile",
        "id": "152",
        "code": "CL",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "China",
        "id": "159",
        "code": "CN",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "China, Hong Kong SAR",
        "id": "344",
        "code": "HK",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "China, Macao SAR",
        "id": "446",
        "code": "MO",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "China, mainland",
        "id": "156",
        "code": "CN",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "China, Taiwan Province of",
        "id": "158",
        "code": "TW",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Colombia",
        "id": "170",
        "code": "CO",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Comoros",
        "id": "174",
        "code": "KM",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Congo",
        "id": "178",
        "code": "CG",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Cook Islands",
        "id": "184",
        "code": "CK",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Costa Rica",
        "id": "188",
        "code": "CR",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "C\u00f4te d'Ivoire",
        "id": "384",
        "code": "CI",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Croatia",
        "id": "191",
        "code": "HR",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Cuba",
        "id": "192",
        "code": "CU",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Cyprus",
        "id": "196",
        "code": "CY",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Czechia",
        "id": "203",
        "code": "CZ",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Democratic People's Republic of Korea",
        "id": "408",
        "code": "KP",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Democratic Republic of the Congo",
        "id": "180",
        "code": "CD",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Denmark",
        "id": "208",
        "code": "DK",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Djibouti",
        "id": "262",
        "code": "DJ",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Dominica",
        "id": "212",
        "code": "DM",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Dominican Republic",
        "id": "214",
        "code": "DO",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Ecuador",
        "id": "218",
        "code": "EC",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Egypt",
        "id": "818",
        "code": "EG",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "El Salvador",
        "id": "222",
        "code": "SV",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Equatorial Guinea",
        "id": "226",
        "code": "GQ",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Eritrea",
        "id": "232",
        "code": "ER",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Estonia",
        "id": "233",
        "code": "EE",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Eswatini",
        "id": "748",
        "code": "SZ",
        "countryCompareId": [
            "018",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Ethiopia",
        "id": "231",
        "code": "ET",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Ethiopia Socioeconomic Survey 2018/2019 (ESS)",
                "href": "https://microdata.worldbank.org/index.php/catalog/3823/study-description"
            }
        ]
    },
    {
        "label": "Fiji",
        "id": "242",
        "code": "FJ",
        "countryCompareId": [
            "054",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Finland",
        "id": "246",
        "code": "FI",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "France",
        "id": "250",
        "code": "FR",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "French Polynesia",
        "id": "258",
        "code": "PF",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Gabon",
        "id": "266",
        "code": "GA",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Gambia",
        "id": "270",
        "code": "GM",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Georgia",
        "id": "268",
        "code": "GE",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": [
            {
                "categoryId": 1,
                "type": "link",
                "name": "Agricultural Holding Survey 2022 Final Survey and Thematic Reports",
                "url": "https://www.geostat.ge/media/54293/soflis_meurneoba_2022.pdf",
                "description": "State of Food and Agriculutre 2022 lorem ipsum description",
                "updated": "2022-03-05",
                "source": "FAO"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "Agricultural Holding Survey 2021 Final Survey and Thematic Reports",
                "url": "https://www.geostat.ge/media/46405/soflis_meurneoba_2021.pdf",
                "description": "Comprehensive food price data for the year 2023",
                "updated": "2024-04-11",
                "source": "FAO"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "Agricultural Holding Survey 2021 Microdata Files",
                "url": "https://www.geostat.ge/en/modules/categories/817/database-of-survey-of-agricultural-holdings-2021",
                "description": "Link to the company homepage",
                "updated": "2024-05-22",
                "source": "FAO"
            },
            {
                "categoryId": 1,
                "type": "link",
                "name": "2021 Production Methods and Environment Survey",
                "url": "https://www.geostat.ge/en/modules/categories/798/production-methods-and-environment",
                "description": "Link to the homepage",
                "updated": "2024-08-20",
                "source": "FAO"
            },
            {
                "categoryId": 2,
                "type": "PDF",
                "label": "Agricultural Holding Survey 2020 Final Survey and Thematic Reports",
                "href": "https://www.geostat.ge/media/38834/soflis_meurneoba_2020.pdf",
                "description": "Link to the PDF lorem ipsum",
                "updated": "2024-08-21",
                "source": "FAO"
            }
        ]
    },
    {
        "label": "Germany",
        "id": "276",
        "code": "DE",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Ghana",
        "id": "288",
        "code": "GH",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Greece",
        "id": "300",
        "code": "GR",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Greenland",
        "id": "304",
        "code": "GL",
        "countryCompareId": [
            "021",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Grenada",
        "id": "308",
        "code": "GD",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Guatemala",
        "id": "320",
        "code": "GT",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Guinea",
        "id": "324",
        "code": "GN",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Guinea-Bissau",
        "id": "624",
        "code": "GW",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Guyana",
        "id": "328",
        "code": "GY",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Haiti",
        "id": "332",
        "code": "HT",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Honduras",
        "id": "340",
        "code": "HN",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Hungary",
        "id": "348",
        "code": "HU",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Iceland",
        "id": "352",
        "code": "IS",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "India",
        "id": "356",
        "code": "IN",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Indonesia",
        "id": "360",
        "code": "ID",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Iran (Islamic Republic of)",
        "id": "364",
        "code": "IR",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Iraq",
        "id": "368",
        "code": "IQ",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Ireland",
        "id": "372",
        "code": "IE",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Israel",
        "id": "376",
        "code": "IL",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Italy",
        "id": "380",
        "code": "IT",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Jamaica",
        "id": "388",
        "code": "JM",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Japan",
        "id": "392",
        "code": "JP",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Jordan",
        "id": "400",
        "code": "JO",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Kazakhstan",
        "id": "398",
        "code": "KZ",
        "countryCompareId": [
            "143",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Kenya",
        "id": "404",
        "code": "KE",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Kiribati",
        "id": "296",
        "code": "KI",
        "countryCompareId": [
            "057",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Kuwait",
        "id": "414",
        "code": "KW",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Kyrgyzstan",
        "id": "417",
        "code": "KG",
        "countryCompareId": [
            "143",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Lao People's Democratic Republic",
        "id": "418",
        "code": "LA",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Latvia",
        "id": "428",
        "code": "LV",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Lebanon",
        "id": "422",
        "code": "LB",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Lesotho",
        "id": "426",
        "code": "LS",
        "countryCompareId": [
            "018",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Liberia",
        "id": "430",
        "code": "LR",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Libya",
        "id": "434",
        "code": "LY",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Lithuania",
        "id": "440",
        "code": "LT",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Luxembourg",
        "id": "442",
        "code": "LU",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Madagascar",
        "id": "450",
        "code": "MG",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Malawi",
        "id": "454",
        "code": "MW",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Integrated Household Panel Survey 2010-2013-2016-2019",
                "href": "https://microdata.worldbank.org/index.php/catalog/3819/study-description"
            }
        ]
    },
    {
        "label": "Malaysia",
        "id": "458",
        "code": "MY",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Maldives",
        "id": "462",
        "code": "MV",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mali",
        "id": "466",
        "code": "ML",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Malta",
        "id": "470",
        "code": "MT",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Marshall Islands",
        "id": "584",
        "code": "MH",
        "countryCompareId": [
            "057",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mauritania",
        "id": "478",
        "code": "MR",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mauritius",
        "id": "480",
        "code": "MU",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mexico",
        "id": "484",
        "code": "MX",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Micronesia (Federated States of)",
        "id": "583",
        "code": "FM",
        "countryCompareId": [
            "057",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mongolia",
        "id": "496",
        "code": "MN",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Montenegro",
        "id": "499",
        "code": "ME",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Morocco",
        "id": "504",
        "code": "MA",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Mozambique",
        "id": "508",
        "code": "MZ",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Myanmar",
        "id": "104",
        "code": "MM",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Namibia",
        "id": "516",
        "code": "NA",
        "countryCompareId": [
            "018",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Naoero",
        "id": "520",
        "code": "NR",
        "countryCompareId": [
            "057",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Nepal",
        "id": "524",
        "code": "NP",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Commercial Livestock Integrated Survey 2021",
                "href": "https://cbs.gov.np/survey-report_commercial-livestock-survey-2021/"
            },
            {
                "label": "Pilot Agriculture Integrated Survey 2019",
                "href": "https://cbs.gov.np/pilot-agriculture-integrated-survey-2019-chitwan/"
            }
        ]
    },
    {
        "label": "Netherlands (Kingdom of the)",
        "id": "528",
        "code": "NL",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "New Caledonia",
        "id": "540",
        "code": "NC",
        "countryCompareId": [
            "054",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "New Zealand",
        "id": "554",
        "code": "NZ",
        "countryCompareId": [
            "053",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Nicaragua",
        "id": "558",
        "code": "NI",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Niger",
        "id": "562",
        "code": "NE",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Nigeria",
        "id": "566",
        "code": "NG",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Niue",
        "id": "570",
        "code": "NU",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "North Macedonia",
        "id": "807",
        "code": "MK",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Norway",
        "id": "578",
        "code": "NO",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Oman",
        "id": "512",
        "code": "OM",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Pakistan",
        "id": "586",
        "code": "PK",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Palau",
        "id": "585",
        "code": "PW",
        "countryCompareId": [
            "057",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Palestine",
        "id": "275",
        "code": "PS",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Panama",
        "id": "591",
        "code": "PA",
        "countryCompareId": [
            "013",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Papua New Guinea",
        "id": "598",
        "code": "PG",
        "countryCompareId": [
            "054",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Paraguay",
        "id": "600",
        "code": "PY",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Peru",
        "id": "604",
        "code": "PE",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Philippines",
        "id": "608",
        "code": "PH",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Poland",
        "id": "616",
        "code": "PL",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Portugal",
        "id": "620",
        "code": "PT",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Puerto Rico",
        "id": "630",
        "code": "PR",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Qatar",
        "id": "634",
        "code": "QA",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Republic of Korea",
        "id": "410",
        "code": "KR",
        "countryCompareId": [
            "030",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Republic of Moldova",
        "id": "498",
        "code": "MD",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Romania",
        "id": "642",
        "code": "RO",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Russian Federation",
        "id": "643",
        "code": "RU",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Rwanda",
        "id": "646",
        "code": "RW",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Saint Kitts and Nevis",
        "id": "659",
        "code": "KN",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Saint Lucia",
        "id": "662",
        "code": "LC",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Saint Vincent and the Grenadines",
        "id": "670",
        "code": "VC",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Samoa",
        "id": "882",
        "code": "WS",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Sao Tome and Principe",
        "id": "678",
        "code": "ST",
        "countryCompareId": [
            "017",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Saudi Arabia",
        "id": "682",
        "code": "SA",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Senegal",
        "id": "686",
        "code": "SN",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "Enquete Agricole Annuelle (2022-2023) Final Report",
                "href": "https://www.dapsa.gouv.sn/content/rapporteaa-20222023"
            },
            {
                "label": "Enquete Agricole Annuelle (2022-2023) DDI Metadata",
                "href": "https://anads.ansd.sn/index.php/catalog/290"
            },
            {
                "label": "Enquete Agricole Annuelle (2022-2023) Microdata Files",
                "href": "https://anads.ansd.sn/index.php/catalog/290"
            },
            {
                "label": "Enquete Agricole Annuelle (2021-2022) Final Report",
                "href": "https://drive.google.com/file/d/1e98ABeSNrehzRk1Sl7FW_Btgtab1vEKJ/view"
            },
            {
                "label": "Enquete Agricole Annuelle (2021-2022) DDI Metadata",
                "href": "http://anads.ansd.sn/index.php/catalog/272"
            },
            {
                "label": "Enquete Agricole Annuelle (2021-2022) Microdata Files",
                "href": "http://anads.ansd.sn/index.php/catalog/272"
            }
        ]
    },
    {
        "label": "Serbia",
        "id": "688",
        "code": "RS",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Seychelles",
        "id": "690",
        "code": "SC",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Sierra Leone",
        "id": "694",
        "code": "SL",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Singapore",
        "id": "702",
        "code": "SG",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Slovakia",
        "id": "703",
        "code": "SK",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Slovenia",
        "id": "705",
        "code": "SI",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Solomon Islands",
        "id": "090",
        "code": "SB",
        "countryCompareId": [
            "054",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Somalia",
        "id": "706",
        "code": "SO",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "South Africa",
        "id": "710",
        "code": "ZA",
        "countryCompareId": [
            "018",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "South Sudan",
        "id": "728",
        "code": "SS",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Spain",
        "id": "724",
        "code": "ES",
        "countryCompareId": [
            "039",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Sri Lanka",
        "id": "144",
        "code": "LK",
        "countryCompareId": [
            "034",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Sudan",
        "id": "729",
        "code": "SD",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Suriname",
        "id": "740",
        "code": "SR",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Sweden",
        "id": "752",
        "code": "SE",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Switzerland",
        "id": "756",
        "code": "CH",
        "countryCompareId": [
            "155",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Syrian Arab Republic",
        "id": "760",
        "code": "SY",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Tajikistan",
        "id": "762",
        "code": "TJ",
        "countryCompareId": [
            "143",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Thailand",
        "id": "764",
        "code": "TH",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Timor-Leste",
        "id": "626",
        "code": "TL",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Togo",
        "id": "768",
        "code": "TG",
        "countryCompareId": [
            "011",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Tokelau",
        "id": "772",
        "code": "TK",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Tonga",
        "id": "776",
        "code": "TO",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Trinidad and Tobago",
        "id": "780",
        "code": "TT",
        "countryCompareId": [
            "029",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Tunisia",
        "id": "788",
        "code": "TN",
        "countryCompareId": [
            "015",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "T\u00fcrkiye",
        "id": "792",
        "code": "TR",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Turkmenistan",
        "id": "795",
        "code": "TM",
        "countryCompareId": [
            "143",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Tuvalu",
        "id": "798",
        "code": "TV",
        "countryCompareId": [
            "061",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Uganda",
        "id": "800",
        "code": "UG",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": [
            {
                "label": "National Panel Survey 2019-2020",
                "href": "https://microdata.worldbank.org/index.php/catalog/3902/study-description"
            },
            {
                "label": "Annual Agricultural Survey 2019 Final Report",
                "href": "https://www.ubos.org/wp-content/uploads/publications/04_2022AAS2019_Report.pdf"
            },
            {
                "label": "Annual Agricultural Survey 2019 Statistical Brief",
                "href": "https://www.ubos.org/wp-content/uploads/publications/05_2022Uganda_UBOS_StatRelease_AAS2019-Final.pdf"
            }
        ]
    },
    {
        "label": "Ukraine",
        "id": "804",
        "code": "UA",
        "countryCompareId": [
            "151",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "United Arab Emirates",
        "id": "784",
        "code": "AE",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "United Kingdom of Great Britain and Northern Ireland",
        "id": "826",
        "code": "GB",
        "countryCompareId": [
            "154",
            "150",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "United Republic of Tanzania",
        "id": "834",
        "code": "TZ",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "United States of America",
        "id": "840",
        "code": "US",
        "countryCompareId": [
            "021",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Uruguay",
        "id": "858",
        "code": "UY",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Uzbekistan",
        "id": "860",
        "code": "UZ",
        "countryCompareId": [
            "143",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Vanuatu",
        "id": "548",
        "code": "VU",
        "countryCompareId": [
            "054",
            "009",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Venezuela (Bolivarian Republic of)",
        "id": "862",
        "code": "VE",
        "countryCompareId": [
            "005",
            "019",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Viet Nam",
        "id": "704",
        "code": "VN",
        "countryCompareId": [
            "035",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Yemen",
        "id": "887",
        "code": "YE",
        "countryCompareId": [
            "145",
            "142",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Zambia",
        "id": "894",
        "code": "ZM",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    },
    {
        "label": "Zimbabwe",
        "id": "716",
        "code": "ZW",
        "countryCompareId": [
            "014",
            "002",
            "001"
        ],
        "usefulLinks": []
    }
]


// The vw_ views now expose the `unit` column they had commented out, so the axis title and
// the data table's Unit column come from the data. The few `unit` entries left below are
// deliberate: either the view returns nothing for that series, or the wording here carries
// more than the code the view holds ("kcal/capita/day" over "kcal/cap/d").
export const CCAsections = [
    {
        value: 'basic-indicators',
        label: ' Basic indicators',
        indicators: [
            {
                label: '',
                slug: 'basic-indicators',
                items: [
                    {
                        label: "Population by 5-year age groups and sex",
                        item_code: ["46"],
                        id: 0,
                        uid: 1,
                        element_code: ["4"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_unpd',
                        chart_type: 'pyramid',
                        flag_sdg: 0,
                        sex_code: ["1", "2"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "De facto population as of 1 July of the year indicated classified by sex (male, female, both sexes combined) and by five-year age groups (0-4, 5-9, 10-14, ..., 95-99, 100+). Data are presented in thousands."
                    },
                    {
                        label: "Population by gender",
                        item_code: ["3010"],
                        id: 1,
                        uid: 2,
                        element_code: ["512", "513"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oa',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator presents the de facto population in a country, area, or region, disaggregated by sex (male and female), as of 1 July of the year indicated. The data is sourced from United Nations, World Population Prospects – the 2015 Revision."
                    },
                    {
                        label: "Population by rural/urban area",
                        item_code: ["3010"],
                        id: 2,
                        uid: 3,
                        element_code: ["551", "561"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oa',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator refers to the de facto population living in areas officially classified as urban or rural, based on each country’s national definition and classification criteria. The population count includes all individuals physically present in those areas as of 1 July of the reference year. The data is sourced from the United Nations World Urbanization Prospects – 2014 Revision, which compiles internationally comparable demographic estimates based on national statistics."
                    },
                    {
                        label: "GDP (constant 2015 US$)",
                        item_code: ["NY.GDP.MKTP.KD"],
                        id: 3,
                        uid: 4,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "GDP (constant 2015 US$) is a measure of a country’s total economic output (gross domestic product) adjusted for price inflation (i.e. in “real” terms), expressed in U.S. dollars, using 2015 as the base/reference year. The Gross Domestic Product (GDP) measures the total gross value added from all institutional units resident in the economy, at producers' prices, plus taxes on imports, less subsidies on imports, plus non-deductible value added taxes (Production approach to GDP). As such, GDP measures the total value created in the production of goods and services by all resident units during the accounting period. The output of most goods or services is usually recorded when their production is completed. However, when it takes a long time to produce a unit of output, it becomes necessary to recognize that output is being produced continuously and to record it as a work-in-progress. For example, the production of certain agricultural goods or large durable goods such as ships or buildings may take months or years to complete. In such cases, it would distort economic reality to treat the output as if it were all produced at the moment of time when the process of production happens to terminate.",
                    },
                    {
                        label: "GDP growth (annual %)",
                        item_code: ["NY.GDP.MKTP.KD.ZG"],
                        id: 4,
                        uid: 5,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "GDP per capita (constant 2015 US$)",
                        item_code: ["NY.GDP.PCAP.KD"],
                        id: 5,
                        uid: 6,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Is an aggegate measure of economic production, representing the total gross value added by all resident producers in an economy, adjusted for inflation (It reflects the true growth of an economy by removing the effects of price changes over time) and expressed in constant US dollars. It includes the value of final goods and services produced, plus taxes and minus subsidies on products not included in the output value. It can also be measured as the sum of all final uses of goods and services (excluding intermediate consumption), minus imports, or as the total primary income distributed by resident production units.",
                    },
                    {
                        label: "GDP per capita, PPP (constant 2021 international $)",
                        item_code: ["NY.GDP.PCAP.PP.KD"],
                        id: 6,
                        uid: 7,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "GDP per capita, PPP (constant 2021 international $) is a measure of the average economic output per person (i.e. GDP divided by population), adjusted for differences in price levels between countries (purchasing power parity, PPP), and expressed in constant (i.e. inflation-adjusted) terms using 2021 as the base year (so that comparisons over time are in real terms). Constant-price GDP per capita is obtained by dividing the constant-price GDP series for each country by its population.",
                    },
                    {
                        label: "SDG 8.1.1: GDP per capita growth (annual %)",
                        item_code: ["NY.GDP.PCAP.KD.ZG"],
                        id: 7,
                        uid: 8,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "Inflation, GDP deflator (annual %)",
                        item_code: ["NY.GDP.DEFL.KD.ZG"],
                        id: 8,
                        uid: 9,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the year-on-year percentage change in the price deflator for GDP. The GDP deflator is computed as the ratio of the GDP in current prices to that in constant (2015) prices (base year) and multiplied by 100. The inflation rate is then the percentage change of that deflator between years.",
                    },
                    {
                        label: "Food price inflation, annualized",
                        item_code: ["23014"],
                        id: 9,
                        uid: 10,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        // exclude_subregional_comparison: true,
                        description: "Food CPI inflation rates are annual year-over-year inflation or percentage change over corresponding month of the previous year. Inflation measured by Food Consumer price index (CPI) is defined as the change in the prices of a basket of goods that are typically purchased by specific groups of households. Inflation is measured in terms of the annual growth rates of the Food CPI.",
                    },
                    {
                        label: "General government final consumption expenditure (% of GDP)",
                        item_code: ["NE.CON.GOVT.ZS"],
                        id: 10,
                        uid: 11,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Government final consumption expenditure consists of expenditure, including imputed expenditure, incurred by general government on both individual consumption goods and services and collective consumption services. Here it is expressed as a percentage of GDP.",
                    },
                    {
                        label: "Total debt service (% of GNI)",
                        item_code: ["DT.TDS.DECT.GN.ZS"],
                        id: 11,
                        uid: 12,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Total debt service is the sum of principal repayments and interest actually paid in currency, goods, or services on long-term debt, interest paid on short-term debt, and repayments (repurchases and charges) to the IMF, expressed as a percentage of that country’s Gross National Income (GNI).",
                    },
                    {
                        label: "Real Value Added (Agriculture, Forestry and Fishing) in US$",
                        item_code: ["22016"],
                        id: 12,
                        uid: 13,
                        element_code: ["6184"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator measures the net output of the agriculture, forestry, and fishing sector, adjusted for inflation and expressed in constant US dollars. It is calculated as the gross output of the sector minus intermediate consumption, representing the contribution of these activities to the overall economy.",
                        exclude_subregional_comparison: true,
                    },
                    {
                        label: "Share of Value Added (Agriculture, Forestry and Fishing) in GDP",
                        item_code: ["22016"],
                        id: 13,
                        uid: 14,
                        element_code: ["6187"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator measures the proportion of the agriculture, forestry, and fishing sector to a country’s Gross Domestic Product (GDP), expressed as a percentage."
                    },
                    {
                        label: "Gross Fixed Capital Formation in US$, 2015 prices",
                        item_code: ["22015"],
                        id: 14,
                        uid: 15,
                        element_code: ["6184"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Refers to the total value of a producer’s acquisitions of fixed assets, minus any disposals, over a given accounting period. It also includes certain increases in the value of non-produced assets (such as subsoil resources or major enhancements to land quantity, quality, or productivity) resulting from productive activities by institutional units. The figures are adjusted for inflation and presented in constant US dollars."
                    },
                    {
                        label: "Gross Fixed Capital Formation in GDP US$, 2015 prices",
                        item_code: ["22015"],
                        id: 15,
                        uid: 16,
                        element_code: ["6187"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator represents the proportion of a country’s Gross Domestic Product (GDP) that is invested in fixed capital assets during a given period. It is calculated as the ratio of Gross Fixed Capital Formation (GFCF) to GDP, expressed as a percentage."
                    },
                    {
                        label: "Gross fixed capital formation (agriculture, forestry and fishing) in total ",
                        item_code: ["22030"],
                        id: 16,
                        uid: 17,
                        element_code: ["61390"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cisp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator measures the total value of investments made by producers in fixed assets within the agriculture, forestry, and fishing sectors during an accounting period. It is calculated as the value of acquisitions minus disposals of such assets, plus certain additions to the value of non-produced assets (e.g. improvements in land, such as irrigation or soil enhancement). Fixed assets include infrastructure, machinery, equipment, buildings, and land development used in the production process. The indicator captures the extent of capital accumulation in the sector, which is critical for enhancing productivity, sustainability, and long-term growth."
                    },
                    {
                        label: "Gross fixed capital formation (agriculture, forestry and fishing) in US$, 2015 prices",
                        item_code: ["22030"],
                        id: 17,
                        uid: 18,
                        element_code: ["61840"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cisp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator measures the total value of investments made by producers in fixed assets within the agriculture, forestry, and fishing sectors during an accounting period. It is calculated as the value of acquisitions minus disposals of such assets, plus certain additions to the value of non-produced assets (e.g. improvements in land, such as irrigation or soil enhancement). Fixed assets include infrastructure, machinery, equipment, buildings, and land development used in the production process. The indicator captures the extent of capital accumulation in the sector, which is critical for enhancing productivity, sustainability, and long-term growth."
                    },
                    {
                        label: "Gross fixed capital formation (agriculture, forestry and fishing) in value added US$, 2015 prices",
                        item_code: ["22030"],
                        id: 18,
                        uid: 19,
                        element_code: ["6192"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cisp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator measures the value of investments made by producers in fixed assets within the agriculture, forestry, and fishing sectors during an accounting period as share of the Gross Domestic Product. The total value of the total gross capital formation is calculated as the value of acquisitions minus disposals of such assets, plus certain additions to the value of non-produced assets (e.g. improvements in land, such as irrigation or soil enhancement). Fixed assets include infrastructure, machinery, equipment, buildings, and land development used in the production process. The indicator captures the extent of capital accumulation in the sector, which is critical for enhancing productivity, sustainability, and long-term growth."
                    },
                    {
                        label: "Rural youth employment-to-population ratio (%), age 15-24, both sexes and by sex - Annual",
                        item_code: ["EMP_DWAP_SEX_AGE_GEO_RT"],
                        id: 19,
                        uid: 20,
                        element_code: ["AGE_YTHADULT_Y15-24"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_dwap',
                        chart_type: 'barChart',
                        urban_rural: ["GEO_COV_RUR"],
                        sex_code: ["SEX_M", "SEX_F"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "It refers to the share of rural youth aged 15–24 who are employed, expressed as a percentage of the total rural youth population in that age group. In line with international standards, employed individuals are those who, during a specified short reference period, were either in paid employment (whether at work or with a job but temporarily absent) or in self employment (whether actively working or temporarily not working in their own enterprise). This indicator is disaggregated by sex and updated annually to monitor labour market participation among rural youth."
                    },
                    {
                        label: "Rural youth time-related underemployment, age 15-24 years, both sexes and by sex",
                        item_code: ["TRU_DEMP_SEX_AGE_GEO_RT"],
                        id: 20,
                        uid: 21,
                        element_code: ["AGE_YTHADULT_Y15-24"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_tru',
                        chart_type: 'barChart',
                        sex_code: ["SEX_M", "SEX_F"],
                        flag_sdg: 0,
                        urban_rural: ["GEO_COV_RUR"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The time-related underemployment rate is a measure of labour underutilization that provides information regarding the share of employed persons who are willing and available to increase their working time (for production within the SNA production boundary) and worked fewer hours than a specified time threshold during the reference period. It signals inadequate employment and complements other indicators of labour slack and labour underutilization such as the unemployment rate and the potential labour force. ILOSTAT contains statistics from national sources on time-related underemployment by sex and age, as well as modelled estimates."
                    },
                    {
                        label: "SDG 8.3.1: Informal employment rate - total and agriculture by sex",
                        item_code: ["SDG_0831_SEX_ECO_RT"],
                        id: 21,
                        uid: 22,
                        element_code: ["ECO_AGNAG_TOTAL", "ECO_AGNAG_TOTAL", "ECO_AGNAG_TOTAL", "ECO_AGNAG_AGR", "ECO_AGNAG_AGR", "ECO_AGNAG_AGR"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_sdg8',
                        chart_type: 'barChart',
                        sex_code: ["SEX_M", "SEX_F", "SEX_T", "SEX_M", "SEX_F", "SEX_T"],
                        flag_sdg: 1,
                        sort_by_element: true,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator presents the share of employment which is classified as informal employment in the total economy, and separately in agriculture and in non-agriculture."
                    },
                    {
                        label: "SDG 8.3.1: Rural youth informal employment rate, age 15-24, both sexes and by sex",
                        item_code: ["EMP_NIFL_SEX_AGE_GEO_RT"],
                        id: 22,
                        uid: 23,
                        element_code: ["AGE_YTHADULT_Y15-24"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_nifl',
                        chart_type: 'barChart',
                        sex_code: ["SEX_M", "SEX_F"],
                        flag_sdg: 1,
                        urban_rural: ["GEO_COV_RUR"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The informal employment rate is the share of persons who are in informal employment as a percent of total employment. Informal employment comprises persons who in their main or secondary jobs were (a) own-account workers, employers and members of producers’ cooperatives employed in their own informal sector enterprises; (b) own-account workers engaged in the production of goods exclusively for own final use by their household (e.g. subsistence farming); (c) contributing family workers, regardless of whether they work in formal or informal sector enterprises; or (d) employees holding informal jobs, whether employed by formal sector enterprises, informal sector enterprises, or as paid domestic workers by households."
                    },
                    {
                        label: "SDG 8.5.2: Adult rural unemployment rate, age 15+ years, both sexes and by sex (%) - Annual",
                        item_code: ["UNE_2EAP_SEX_AGE_GEO_RT"],
                        id: 23,
                        uid: 24,
                        element_code: ["AGE_YTHADULT_YGE15"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_unemp',
                        chart_type: 'barChart',
                        sex_code: ["SEX_M", "SEX_F"],
                        flag_sdg: 1,
                        urban_rural: ["GEO_COV_RUR"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the share of the labor force in the rural areas ages 15+ without work but available for and seeking employment."
                    },
                    {
                        label: "SDG 8.5.2: Adult unemployment rate, age 15+ years, both sexes, national, rural and urban (%) - Annual",
                        item_code: ["UNE_2EAP_SEX_AGE_GEO_RT"],
                        id: 24,
                        uid: 25,
                        element_code: ["AGE_YTHADULT_YGE15"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_unemp',
                        chart_type: 'barChart',
                        sex_code: ["SEX_T"],
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator measures the proportion of the adult labour force aged 15 + years who are unemployed. According to international standards, unemployed individuals are those who, during the reference period, were without work (i.e., not in paid employment or self employment), were currently available for work, and had actively sought employment through specific steps during a recent period. The unemployment rate is expressed as a percentage of the total labour force, which includes both employed and unemployed individuals. This indicator is reported annually and disaggregated by sex and place of residence (national, rural, and urban)."
                    },
                    {
                        label: "SDG 8.5.2: Youth rural unemployment rate, age 15-24 years, both sexes and by sex (%) - Annual",
                        item_code: ["UNE_2EAP_SEX_AGE_GEO_RT"],
                        id: 25,
                        uid: 26,
                        element_code: ["AGE_YTHADULT_Y15-24"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_unemp',
                        chart_type: 'barChart',
                        sex_code: ["SEX_M", "SEX_F"],
                        flag_sdg: 1,
                        urban_rural: ["GEO_COV_RUR"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the share of the labor force ages 15-24 without work but available for and seeking employment."
                    },
                    {
                        label: "SDG 8.5.2: Youth unemployment rate, age 15-24 years, both sexes, national, rural and urban (%) - Annual",
                        item_code: ["UNE_2EAP_SEX_AGE_GEO_RT"],
                        id: 26,
                        uid: 27,
                        element_code: ["AGE_YTHADULT_Y15-24"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_unemp',
                        chart_type: 'barChart',
                        sex_code: ["SEX_T"],
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The unemployment rate is the share of persons who are unemployed as a percent of the labour force. The unemployed comprise all persons of working age who were: a) without work during the reference period, i.e. were not in paid employment or self-employment; b) currently available for work, i.e. were available for paid employment or self-employment during the reference period; and c) seeking work, i.e. had taken specific steps in a specified recent period to seek paid employment or self-employment. The labour force is the sum of all persons of working age who are employed and those who are unemployed."
                    },
                    {
                        label: "Women employment-to-population ratio, age 15+ (%), national, rural and urban - Annual",
                        item_code: ["EMP_DWAP_SEX_AGE_GEO_RT"],
                        id: 27,
                        uid: 28,
                        element_code: ["AGE_YTHADULT_YGE15"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ilo_dwap',
                        chart_type: 'barChart',
                        urban_rural: ["GEO_COV_NAT"],
                        sex_code: ["SEX_F"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "It represents the proportion of the female population aged 15+ years who are employed, relative to the total number of women in that age group. In accordance with international definitions, employed women are those who, during a specified brief reference period, were engaged in paid employment (either at work or with a job but not currently at work) or in self–employment (either working or temporarily absent from their enterprise). This indicator is reported annually and disaggregated by location (national, rural, and urban)."
                    },
                    {
                        label: "SDG 4.6.1: Youth literacy rate, population 15-24 years, both sexes and by sex (%)",
                        item_code: ["LR.AG15T24.M", "LR.AG15T24.F", "LR.AG15T24"],
                        id: 28,
                        uid: 29,
                        element_code: ["LR.AG15T24.M", "LR.AG15T24.F", "LR.AG15T24"],
                        // The UNESCO views carry no `item` column, so without this the legend would
                        // fall back to the raw codes. Wording taken from the views' own `sex` column.
                        label_by_item: { "LR.AG15T24.M": "Males", "LR.AG15T24.F": "Females", "LR.AG15T24": "Total" },
                        domain_code: 'fao-dwh-review.fao_cca.vw_unesco_sdg',
                        chart_type: 'barChart',
                        sex_code: ["LR.AG15T24.M", "LR.AG15T24.F", "LR.AG15T24"],
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The proportion of youth (aged 15-24 years) who have achieved or exceeded a fixed level of proficiency (FLP) in (a) literacy and (b) numeracy. FLP is the benchmark of basic knowledge in a domain (literacy or numeracy) measured through learning assessments. Currently, the FLP for global reporting is the Programme for the International Assessment of Adult Competencies (PIAAC) level 2 descriptor. The concepts of functional literacy and functional numeracy are based on the UNESCO definitions, which cover a continuum of proficiency levels rather than a dichotomy. A person is functionally literate if he/she can engage in all those activities in which literacy is required for the effective functioning of his/her group and community and also which enables them to continue to use reading, writing and calculation for his/her own and the community’s development."
                    },
                    {
                        label: "SDG 4.6.1: Adult literacy rate, population 15+ years, both sexes and by sex (%)",
                        item_code: ["LR.AG15T99.M", "LR.AG15T99.F", "LR.AG15T99"],
                        id: 29,
                        uid: 30,
                        element_code: ["LR.AG15T99.M", "LR.AG15T99.F", "LR.AG15T99"],
                        // The UNESCO views carry no `item` column, so without this the legend would
                        // fall back to the raw codes. Wording taken from the views' own `sex` column.
                        label_by_item: { "LR.AG15T99.M": "Males", "LR.AG15T99.F": "Females", "LR.AG15T99": "Total" },
                        domain_code: 'fao-dwh-review.fao_cca.vw_unesco_sdg',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        sex_code: ["LR.AG15T99.M", "LR.AG15T99.F", "LR.AG15T99"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The proportion of adults (aged 15 years and above) who have achieved or exceeded a fixed level of proficiency (FLP) in (a) literacy and (b) numeracy. FLP is the benchmark of basic knowledge in a domain (literacy or numeracy) measured through learning assessments. Currently, the FLP for global reporting is the Programme for the International Assessment of Adult Competencies (PIAAC) level 2 descriptor. The concepts of functional literacy and functional numeracy are based on the UNESCO definitions, which cover a continuum of proficiency levels rather than a dichotomy. A person is functionally literate if he/she can engage in all those activities in which literacy is required for the effective functioning of his/her group and community and also which enables them to continue to use reading, writing and calculation for his/her own and the community’s development."
                    },
                    {
                        label: "Hidden costs of agrifood systems 2020",
                        item_code: ["2"],
                        id: 30,
                        uid: 31,
                        // The view has no unit column: SOFA 2023 expresses hidden costs in 2020 PPP dollars.
                        unit: "2020 PPP dollars",
                        element_code: ["1", "2", "3"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sofa',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The “hidden costs of agrifood systems (2020)” refer to the estimated external costs (i.e. costs not reflected in market prices) associated with the production, distribution, consumption, and disposal of food (i.e. the agrifood system). These costs include negative health, environmental, and social impacts that are borne by society rather than by the actors in the food system.",
                    },
                    {
                        label: "Consumer price indices, December (2015 = 100)",
                        item_code: ["23013", "23012"],
                        id: 31,
                        uid: 32,
                        element_code: ["6125"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cp',
                        chart_type: 'stackedBar',
                        unit: "Index (2015=100)",
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "",
                    },
                    {
                        label: "Food exports and imports in total merchandise (%)",
                        item_code: ["TM.VAL.FOOD.ZS.UN", "TX.VAL.FOOD.ZS.UN"],
                        element_code: [],
                        id: 32,
                        uid: 33,
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: ""
                    },
                    {
                        label: "Population ages 0-14 (% of total population)",
                        item_code: ["SP.POP.0014.TO.ZS"],
                        element_code: [],
                        id: 33,
                        uid: 34,
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: ""
                    },
                    {
                        label: "Rural population (% of total population)",
                        item_code: ["SP.RUR.TOTL.ZS"],
                        element_code: [],
                        id: 34,
                        uid: 35,
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: ""
                    }
                ]
            }
        ]
    },
    {
        value: 'enhanced-pre-post-production',
        label: '1. Enhanced Production: From Pre-to Post-Production',
        indicators: [
            {
                label: '1.1 Primary Production',
                slug: 'primary-production',
                items: [
                    {
                        label: "Total factor productivity in agriculture",
                        subtheme: "1.1.1 Total factor productivity",
                        item_code: ["1"],
                        //indicator_code: ["1"],
                        id: 0,
                        uid: 36,
                        element_code: ["TFP_Index"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_usda',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Total Factor Productivity (TFP) is the ratio of the index of output to Input. The index AG TFP is calculated using the difference between the growth rates of Output (total) and Inputs, and applying that growth rate to the 2015 base year of the AG TFP index. TFP measures the amount of agricultural output produced from the combined set of land, labor, capital, and material resources employed in farm production. If total output is growing faster than total inputs, then the total productivity of the factors of production (i.e., total factor productivity) is increasing."
                    },
                    {
                        label: "Agriculture value added per worker (constant 2015 US$)",
                        subtheme: "1.1.1 Total factor productivity",
                        item_code: ["21085"],
                        id: 1,
                        uid: 37,
                        element_code: ["6228"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Computation based on data from FAOSTAT and ILOSTAT: This indicator provides information on the output of the agricultural sector by worker engaged. It is a measure of agricultural productivity. The data on the value added in agriculture, forestry and fisheries (in US$, 2015 prices) is extracted from FAOSTAT and then divided by the number of people employed in agriculture, forestry and fishing extracted from ILOSTAT for a given year in a given country."
                    },
                    {
                        label: "Value of agricultural production (Int. $) per area of agricultural land",
                        subtheme: "1.1.1 Total factor productivity",
                        item_code: ["6610"],
                        id: 2,
                        uid: 38,
                        element_code: ["7278"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator provides information on the output of the agricultural sector by worker engaged. It is a measure of agricultural productivity. The data on the value added in agriculture, forestry, and fisheries (in US$, 2015 prices) is extracted from FAOSTAT and then divided by the number of people employed in agriculture (in broad sense) extracted from ILOSTAT for a given year in a given country.",
                    },
                    {
                        label: "SDG 2.3.1: Productivity of food producers by scale by sex",
                        subtheme: "1.1.1 Total factor productivity",
                        item_code: ["24015-M", "24015-F", "24015-_T", "24016-M", "24016-F", "24016-_T"],
                        id: 3,
                        uid: 39,
                        element_code: ["6174"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        sort_by_item: true,
                        // Plot the items on the X axis and one series per year (the default
                        // bar chart does the opposite). Only affects the chart, not the table.
                        series_by_year: true,
                        description: "The concept of productivity is standardized by OECD’s Manual for Measuring Productivity. This defines productivity as “a ratio of a volume measure of outputs to a volume measure of input use”. Small-scale food producers are defined as those falling in the intersection of the bottom 40 percent of the cumulative distribution of land, livestock and revenues."
                    },
                    {
                        label: "Crop yield",
                        subtheme: "1.1.2 Crop Production",
                        item_code: ["1717", "1804", "1738", "1726", "1720", "1729", "1735", "1723", "1732", "17530", "1841"],
                        id: 4,
                        uid: 40,
                        element_code: ["5412"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                        description: "Crop yield: Harvested production per unit of harvested area for crop products. In most of the cases yield data are not recorded but obtained by dividing the production data by the data on area harvested. Data on yields of permanent crops are not as reliable as those for temporary crops either because most of the area information may correspond to planted area, as for grapes, or because of the scarcity and unreliability of the area figures reported by the countries, as for example for cocoa and coffee.",
                    },
                    {
                        label: "Cereals yield",
                        subtheme: "1.1.2 Crop Production",
                        item_code: ["44", "89", "108", "56", "79", "75", "27", "71", "83", "97", "15"],
                        id: 5,
                        uid: 41,
                        element_code: ["5412"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                        // Same FAOSTAT element (5412, Yield) as "Crop yield": same description.
                        description: "Crop yield: Harvested production per unit of harvested area for crop products. In most of the cases yield data are not recorded but obtained by dividing the production data by the data on area harvested. Data on yields of permanent crops are not as reliable as those for temporary crops either because most of the area information may correspond to planted area, as for grapes, or because of the scarcity and unreliability of the area figures reported by the countries, as for example for cocoa and coffee.",
                    },
                    {
                        label: "Yield of beef and buffalo meat",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1806"],
                        id: 6,
                        uid: 42,
                        element_code: ["5417"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                        description: "Yield of beef and buffalo meat refers to the average carcass weight of meat obtained per animal slaughtered, expressed in kilograms per head. Production of beef and buffalo meat includes veal.",
                    },
                    {
                        label: "Yield of pork",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1035"],
                        id: 7,
                        uid: 43,
                        element_code: ["5417"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                        description: "Yield of pork refers to the average carcass weight of meat obtained per animal slaughtered, expressed in kilograms per head.",
                    },
                    {
                        label: "Yield of poultry meat",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1808"],
                        id: 8,
                        uid: 44,
                        element_code: ["5424"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Yield of poultry meat refers to the average amount of poultry meat produced per animal, expressed in grams per head. The term 'poultry' covers domestic fowls, guinea fowl, ducks, geese and turkeys.",
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                    },
                    {
                        label: "Yield of sheep and goat meat",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1807"],
                        id: 9,
                        uid: 45,
                        element_code: ["5417"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Yield of sheep and goat meat refers to the average carcass weight of meat obtained per animal slaughtered, expressed in kilograms per head (unofficial description)",
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                    },
                    {
                        label: "Yield of raw milk of cattle",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["882"],
                        id: 10,
                        uid: 46,
                        element_code: ["5510"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        metadata_blacklist: ['QCL\\Hen_Eggs_technical_conversion_factor.pdf'],
                        description: "This refers to the average amount of raw milk produced per milking cattle (or per cow) in a given period (annually). This subclass includes milk, raw, of cattle. This subclass does not include milk with a fat content of less than 3.5%, skimmed or partially skimmed",
                    },
                    {
                        label: "Yield of eggs",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1783"],
                        id: 11,
                        uid: 47,
                        element_code: ["5424"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the average number of eggs produced per laying bird during a given reference period (annually). Egg production by type of poultry should refer to the total production of eggs in the shell by all types of hens in both the traditional sector (individually owned small flocks) and the modern sector (large-scale, intensive commercial poultry farms). This include eggs for hatching but exclude waste of farms.",
                    },
                    {
                        label: "Gross production value (constant 2014-2016 thousand I$) of agriculture",
                        subtheme: "1.1.1 Total factor productivity",
                        item_code: ["2051"],
                        id: 12,
                        uid: 48,
                        element_code: ["152"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qv',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Gross Production Value (constant 2014-2016 thousand US$) is an indicator capturing the monetary value of all agricultural (crop + livestock + fisheries) output at farm-gate, measured in constant prices of the base period 2014-2016, and expressed in thousands of U.S. dollars. It reports the gross output (i.e. before subtracting intermediate inputs) converted into a fixed price basis so that comparisons over time are not distorted by price changes or inflation.",
                    },
                    {
                        label: "Gross production value (constant 2014-2016 thousand I$) of crops",
                        subtheme: "1.1.2 Crop Production",
                        item_code: ["2041", "1717", "1720", "1723", "1730", "1735", "1738", "1753"],
                        id: 13,
                        uid: 49,
                        element_code: ["152"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qv',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The value of gross production is compiled by multiplying gross production in physical terms by output prices at farm gate, thus representing value a measures of the agricultural production in monetary terms at the farm gate level. Since intermediate uses within the agricultural sector (seed and feed) have not been subtracted from production data, this value of production aggregate refers to the notion of 'gross production'.",
                        exclude_subregional_comparison: true,
                    },
                    {
                        label: "Meat production quantity",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1765", "1806", "1807", "1808", "1035"],
                        id: 14,
                        uid: 50,
                        element_code: ["5510"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'stackedBar',
                        unit: "tonnes",
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This is the total quantity of meat produced in a country in a given year, measured in tonnes. It represents the aggregation of meat output from various livestock species with the bone in (cattle, pigs, poultry, sheep, goats, etc.) before any processing losses, whether fresh or chilled. FAO defines meat as the flesh of animals used for food. In production data, meat is normally reported inclusive of bone and exclusive of meat that is unfit for human consumption. As reported by individual countries, meat production data may refer either to commercial production (meat entering marketing channels), inspected production (from animals slaughtered under sanitary inspection), or total production (the total of the above- mentioned categories plus slaughter for personal consumption). All FAO annual production data refer to total production.Country statistics on meat production adhere to one or more of the following concepts: 1. Live weight: the weight of the animal immediately before slaughter. 2. Killed weight: the live weight less the uncollected blood lost during slaughter. 3. Dressed carcass weight: weight minus all parts - edible and inedible - that are removed in dressing the carcass. The concept varies widely from country to country and according to the various species of livestock. Edible parts generally include edible offals (head or head meat, tongue, brains, heart, liver, spleen, stomach or tripes and, in a few countries, other parts such as feet, throat and lungs. Slaughter fats (the unrendered fats that fall in the course of dressing the carcasses) are recorded as either edible or inedible according to country practice. Inedible parts generally include hides and skins (except in the case of pigs), as well as hoofs and stomach contents.Among individual countries, one of the following three concepts issued to measure production:A. Production from all animals, of both indigenous and foreign origin, that are slaughtered within national boundaries. B. Production from the slaughter of indigenous animals plus exports of live indigenous animals during the reference period. Derived from meat production as follows: production from slaughtered animals plus the meat equivalent of all animals exported alive, minus the meat equivalent of all animals imported alive. As imports/exports of live animals are recorded by FAO in numbers, not weight, animal type and size are of significance. C. The biological production concept covers indigenous animals that are either slaughtered or exported live, plus net additions to the stock during the reference period. Derived from indigenous productions follows: indigenous production plus (or minus) the meat equivalent of the change in the stock numbers during the reference period. Production is expressed in terms of live weight. Changes in the total live weight of all animals are not taken into account.FAO uses the first concept of meat production in the construction of its food balance sheets and for related indicators. The second concept, indigenous meat production, in measuring the output of the national livestock sector, is useful mainly in the construction of index numbers of agricultural production. The third concept, biological production, would be the most complete as it also reflects changes in the livestock herd, but it is not used because of difficulties in obtaining information from national reporting offices. The prices applied to indigenous meat production are derived from prices of live animals. This covers not only the value of meat, but also the value of offals, fats, hides and skins.Beef and Veal, Dried, Salted, Smok Meat of bovine animals, whether salted, in brine, dried or smoked. Includes edible flours and meals.Beef and Veal Preparations nes Meat and offal (o/t liver) that are boiled, steamed, grilled, fried, roasted or otherwise cooked. Includes prepared meals that contain more than 20% of meat and offal by weight.BUFFALO MEAT Fresh, chilled or frozen, with bone in or boneless.OFFALS OF BUFFALO, EDIBLE Fresh, chilled or frozen.",
                    },
                    {
                        label: "Dairy production quantity",
                        subtheme: "1.1.3 Livestock Production",
                        // Milk against eggs: same unit, but milk is around thirty times larger
                        // and squashes the egg series onto the baseline. Each gets its own axis.
                        dual_axis: true,
                        item_code: ["1780", "1783"],
                        id: 15,
                        uid: 51,
                        element_code: ["5510"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "This refers to the total amount of raw milk (all dairy animals combined, or a specific subset such as cattle) produced in a country during a given period (a year). This includes milk output consumed by producers (household/farm use), marketed milk, and milk used in further processing. About 70 percent of whole milk is processed into dairy products; the byproducts of these processes (e.g. skim milk, buttermilk and whey) are used either for feed or are manufactured into other dairy products, e.g. dry skim milk and low-fat cheese. FAO lists 50 milk and dairy products items",
                    },
                    {
                        label: "Gross Production Value (constant 2014-2016 thousand I$) of livestock",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["2044", "944", "1055", "1012", "1032", "1094", "1770"],
                        id: 16,
                        uid: 52,
                        element_code: ["152"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qv',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Gross Production Value (constant 2014-2016 thousand I$) of livestock measures the gross monetary output of livestock (meat, milk, eggs, hides, etc.) for a country, valued in constant price terms using the base period 2014–2016, and expressed in international dollars (I$) to adjust for purchasing power parity (PPP) across countries. It does not subtract input costs (i.e. it is “gross,” not “net”), and reflects the full value of livestock outputs at farm–gate, using uniform reference prices so comparisons over time and across countries are meaningful.",
                    },
                    {
                        label: "Gross Production Value (constant 2014-2016 thousand I$) of dairy products",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["1062", "1780"],
                        id: 17,
                        uid: 53,
                        element_code: ["152"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_qv',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "“Gross Production Value (constant 2014-2016 thousand I$) of dairy products” represents the total monetary value of dairy product output (e.g., milk, cheese, butter, etc.) at the farm or producer level, expressed in international dollars (I$) adjusted for purchasing power parity, and fixed in 2014-2016 constant price terms. It is a gross output indicator, meaning it does not subtract the value of input costs (feed, labour, veterinary, etc.). The “constant” valuation enables comparisons over time and across countries by neutralizing distortions from inflation, exchange rate fluctuations, or local price level differences.",
                    },
                    {
                        label: "Aquaculture production of aquatic animals by ISSCAAP divisions of species (tonnes - live weight)",
                        subtheme: "1.1.4 Fisheries and Aquaculture",
                        item_code: ["1", "2", "3", "4", "5", "7"],
                        id: 18,
                        uid: 54,
                        element_code: ["BRACKISHWATER", "FRESHWATER", "MARINE"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fishstat_production',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Aquaculture production of aquatic animals includes all aquatic animals originating from aquaculture. Aquatic animals includes all types of fish, crustaceans, molluscs and other aquatic animals, with the exception of aquatic mammals and reptiles, which are excluded because their statistics are only available in individual catches (in numbers and not in weight). Aquatic products such as corals, pearls, shells and sponges are excluded."
                    },
                    {
                        label: "Capture fisheries production of aquatic animals by ISSCAAP divisions of species (tonnes - live weight)",
                        subtheme: "1.1.4 Fisheries and Aquaculture",
                        item_code: ["1", "2", "3", "4", "5", "7"],
                        id: 19,
                        uid: 55,
                        element_code: ["CAPTURE"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fishstat_production',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Capture fisheries production of aquatic animals includes all aquatic animals originating from capture fisheries. Aquatic animals includes all types of fish, crustaceans, molluscs and other aquatic animals, with the exception of aquatic mammals and reptiles, which are excluded because their statistics are only available in individual catches (in numbers and not in weight). Aquatic products such as corals, pearls, shells and sponges are excluded."
                    },
                    {
                        label: "Permanent meadows and pastures",
                        subtheme: "1.1.3 Livestock Production",
                        item_code: ["6655", "6655"],
                        id: 20,
                        uid: 56,
                        element_code: ["5110", "7208"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'multipleAxis',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Permanent meadows and pastures is the land used permanently (five years or more) to grow herbaceous forage crops, either cultivated or growing wild (wild prairie or grazing land). The land under this category is not rotated with other crops—its main function is for forage/grazing, not for cropping cycles. If trees or shrubs are present (wooded pasture or agroforestry), the area is still classified under “permanent meadows and pastures” only if the principal use is herbaceous forage (i.e. the forage function dominates). This class may include: • Grazing in wooded or shrubby zones (e.g. under low tree cover) • Mountain or subalpine meadows, transhumance grasslands, steppes, dry meadows used for grazing",
                    },
                    {
                        label: "Plantation forest area",
                        subtheme: "1.1.5 Forestry",
                        item_code: ["1"],
                        id: 21,
                        uid: 57,
                        element_code: ["2"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_fra',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Plantation forest (Sub-category of Planted forest) Plantation forest is the planted forest that is intensively managed and meet ALL the following criteria at planting and stand maturity: one or two species, even age class, and regular spacing. Explanatory notes 1. Specifically includes: short rotation plantation for wood, fibre and energy. 2. Specifically excludes: forest planted for protection or ecosystem restoration. 3. Specifically excludes: Forest established through planting or seeding which at stand maturity resembles or will resemble naturally regenerating forest. For reference, Planted forest is the forest predominantly composed of trees established through planting and/or deliberate seeding."
                    },
                    {
                        label: "Production of roundwood by type",
                        subtheme: "1.1.5 Forestry",
                        item_code: ["1627", "1628", "1866", "1867"],
                        id: 22,
                        uid: 58,
                        element_code: ["5516"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fo',
                        chart_type: 'line',
                        chart_stack: 'area',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The solid volume or weight of all production of the sawnwood. This includes production from all sources within the country including public, private, and informal sources. It is reported in cubic metres of solid volume in the case of roundwood. WOOD IN THE ROUGH (ROUNDWOOD): All roundwood felled or otherwise harvested and removed. It comprises all wood obtained from removals, i.e. the quantities removed from forests and from trees outside the forest, including wood recovered from natural, felling and logging losses during the period, calendar year or forest year. It includes all wood removed with or without bark, including wood removed in its round form, or split, roughly squared or in other form (e.g. branches, roots, stumps and burls, where these are harvested) and wood that is roughly shaped or pointed. It is an aggregate comprising wood fuel, including wood for charcoal and industrial roundwood (wood in the rough)."
                    },
                    {
                        label: "Production of selected forest products",
                        unit_by_item: { "1630": 't', "1872": 'm3' },
                        subtheme: "1.1.5 Forestry",
                        item_code: ["1872", "1630"],
                        id: 23,
                        uid: 59,
                        element_code: ["5516", "5510"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fo',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "Non-wood forest product removals and value",
                        subtheme: "1.1.5 Forestry",
                        item_code: ["1"],
                        id: 24,
                        uid: 60,
                        element_code: ["3"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_fra',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Non-wood forest products removals and value Non-wood forest product Goods derived from forests that are tangible and physical objects of biological origin other than wood. Explanatory notes 1. Generally includes non-wood plant and animal products collected from areas defined as forest (see definition of forest). 2. Specifically includes the following regardless of whether from natural forests or plantations: - gum arabic, rubber/latex and resin; - Christmas trees, cork, bamboo and rattan. 3. Generally excludes products collected in tree stands in agricultural production systems, such as fruit tree plantations, oil palm plantations and agroforestry systems when crops are grown under tree cover. 4. Specifically excludes the following: - woody raw materials and products, such as chips, charcoal, fuelwood and wood used for tools, household equipment and carvings; - grazing in the forest; - fish and shellfish. Value of non-wood forest product For the purpose of reporting on this variable, value is defined as the commercial market value at the forest gate. Explanatory notes 1. If values are obtained from a point further down the production chain, transport costs and possible handling and/or processing costs should be subtracted whenever possible. 2. Commercial value refers to actual market value and potential value of both marketed and non-marketed products."
                    },
                    {
                        label: "Soil carbon stock in forest land",
                        subtheme: "3.1.3 Soil quality (health) and Nutrient Management",
                        item_code: ["6646"],
                        id: 25,
                        uid: 61,
                        element_code: ["72151"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Soil carbon is organic carbon in mineral and organic soils (including peat) to a specified depth chosen by the country and applied consistently through the time series. Soil carbon stock in forest land refers to the amount (mass) of organic carbon stored in the soil (both mineral and organic soil layers, possibly including peat) under lands classified as forest.",
                    },
                ]
            },
            {
                label: '1.2 Post-production',
                slug: 'post-production',
                items: [
                    {
                        label: "Value added (manufacture of food, beverages and tabacco products) in US$, 2015 prices",
                        subtheme: "1.4.4 Food Processing and adding value",
                        item_code: ["22076"],
                        id: 0,
                        uid: 62,
                        element_code: ["6184"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Data on value added of manufacturing of Food, beverages and tobacco products (VA_FBT) originates from the UNIDO INDSTAT2 and are then adjusted to match the national accounts (NA) series levels of Value added of total manufacturing (VA_MAN) from UNSD Analysis of Main Aggregates (UNSD AMA). In an attempt to restore comparability with NA based series, the UNIDO based series on VA_FBT are rescaled to match the NA levels by the use of sectorial composition ratios (value added of FBT over value added of total manufacturing from UNIDO database). These ratios that are compiled with UNIDO data are then applied to the NA series on value added of total manufacturing available from the UNSD AMA database. The approach taken is based on the assumption that similar industry structure are obtained from the two sources (e.g. similar relative size of the FBT sector in total manufacturing) even if the series in levels may differ."
                    },
                    {
                        label: "Annual growth of value added (manufacture of food, beverages and tabacco products) US$, 2015 prices",
                        subtheme: "1.4.4 Food Processing and adding value",
                        item_code: ["22076"],
                        id: 1,
                        uid: 63,
                        element_code: ["6182"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_mk',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Data on value added of manufacturing of Food, beverages and tobacco products (VA_FBT) originates from the UNIDO INDSTAT2 and are then adjusted to match the national accounts (NA) series levels of Value added of total manufacturing (VA_MAN) from UNSD Analysis of Main Aggregates (UNSD AMA). In an attempt to restore comparability with NA based series, the UNIDO based series on VA_FBT are rescaled to match the NA levels by the use of sectorial composition ratios (value added of FBT over value added of total manufacturing from UNIDO database). These ratios that are compiled with UNIDO data are then applied to the NA series on value added of total manufacturing available from the UNSD AMA database. The approach taken is based on the assumption that similar industry structure are obtained from the two sources (e.g. similar relative size of the FBT sector in total manufacturing) even if the series in levels may differ.",
                        exclude_subregional_comparison: true,
                    },
                    {
                        label: "Production volumes of processed aquatic products by ISSCAAP divisions of species (tonnes - net product weight)",
                        subtheme: "1.4.4 Food Processing and adding value",
                        item_code: ['1', '2', '3', '4', '5', '6'],
                        id: 2,
                        uid: 64,
                        element_code: ['1'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fishstat_processed',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    }
                ]
            },
            {
                label: '1.3 Agricultural inputs and services',
                slug: 'agricultural-inputs-and-services',
                items: [
                    {
                        label: "SDG 6.4.1: Water Use Efficiency in Agriculture (ISIC4 A01 A0210 A0322)",
                        subtheme: "1.2.9 Water efficiency",
                        item_code: ["24028-A"],
                        id: 0,
                        uid: 65,
                        element_code: ["6178"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Water Use Efficiency (WUE) in agriculture is defined as the value added of agriculture, forestry and fishing divided by the volume of water used."
                    },
                    {
                        label: "SDG 2.4.1: Proportion of agricultural area under productive and sustainable agriculture",
                        subtheme: "1.2.4 Soils",
                        item_code: ["24046"],
                        id: 1,
                        uid: 66,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The scope of indicator 2.4.1 is the agricultural farm holding, and more precisely the agricultural land area of the farm holding, i.e. land used primarily to grow crops and raise livestock. This choice of scope is fully consistent with the intended use of a country’s agricultural land area as the denominator of the aggregate indicator. Legend - Trend towards productive and sustainable agriculture: 1 to <1.5 Deterioration away from productive and sustainable agriculture; 1.5 to <2.5 Slight deterioration from productive and sustainable agriculture; 2.5 to <3.5 No improvement towards productive and sustainable agriculture; 3.5 to <4.5 Slight improvement towards productive and sustainable agriculture; 4.5 to 5 Improvement towards productive and sustainable agriculture. Current status with respect to productive and sustainable agriculture: 1 to <1.5 Very far from achieving productive and sustainable agriculture; 1.5 to <2.5 Far from achieving productive and sustainable agriculture; 2.5 to <3.5 At a moderate distance to achieving productive and sustainable agriculture; 3.5 to <4.5 Close to achieving productive and sustainable agriculture; 4.5 to 5 Productive and sustainable agriculture already achieved."
                    },
                    {
                        label: "Agriculture Water Withdrawal as percentage of total water withdrawals",
                        subtheme: "1.2.8 Water usage: for irrigation, food processing, animal and human consumption, waste water",
                        item_code: ["4254"],
                        id: 2,
                        uid: 67,
                        element_code: ["102"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aqua',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the share of total annual freshwater withdrawals (i.e. the volume of water abstracted for all uses) that is used by the agricultural sector (including irrigation, livestock, aquaculture) in a given year.",
                    },
                    {
                        label: "Water withdrawal for livestock",
                        subtheme: "1.2.8 Water usage: for irrigation, food processing, animal and human consumption, waste water",
                        item_code: ["4476"],
                        id: 3,
                        uid: 68,
                        element_code: ["102"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aqua',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the annual volume of water abstracted (withdrawn) for livestock-related uses, including watering animals, cleaning of facilities (stables, barns), dairy operations, and other on-farm needs.",
                    },
                    {
                        label: "Land area equipped for irrigation",
                        subtheme: "1.2.8 Water usage: for irrigation, food processing, animal and human consumption, waste water",
                        item_code: ["6690", "6690"],
                        id: 4,
                        uid: 69,
                        element_code: ["5110", "7252"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'multipleAxis',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Area equipped for irrigation: area equipped for full control irrigation + equipped lowlands area + spate irrigation area. Land area equipped for irrigation infrastructure and equipment to provide water to crops, which are in working order. The equipment does not have to be used during the reference year. The area equipped for irrigation covers areas equipped for fully controlled irrigation by any of the methods of surface, sprinkler or localized irrigation. It also includes areas under partially controlled irrigation methods of spate irrigation (controlling flood waters to water crops), equipped wetlands and inland valley bottoms and equipped flood recession. It excludes manual watering of plants using buckets, watering cans or other devices. Land area equipped with irrigation infrastructure and equipment to provide water to crops, which are in working order. The equipment does not have to be used during the reference year. The area equipped for irrigation covers areas equipped for fully controlled irrigation by any of the methods of surface, sprinkler or localized irrigation. It also includes areas under partially controlled irrigation methods of spate irrigation (controlling flood waters to water crops), equipped wetlands and inland valley bottoms and equipped flood recession. It excludes manual watering of plants using buckets, watering cans or other devices.",
                    },
                    {
                        label: "Share of the cultivated area equipped for irrigation",
                        subtheme: "1.2.8 Water usage: for irrigation, food processing, animal and human consumption, waste water",
                        item_code: ["4331"],
                        id: 5,
                        uid: 70,
                        element_code: ["103"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aqua',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the proportion (percentage) of land under cultivation ( arable land + permanent crops) that is equipped with irrigation infrastructure.",
                    },
                    {
                        label: "Agriculture area actually irrigated (%)",
                        subtheme: "1.2.8 Water usage: for irrigation, food processing, animal and human consumption, waste water",
                        item_code: ["4463"],
                        id: 6,
                        uid: 71,
                        element_code: ["103"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aqua',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This refers to the share (percentage) of a country’s agricultural land (i.e. cropland + permanent crops) that is actually irrigated in a given year (i.e. receives water through irrigation). Importantly, this is not just the area equipped for irrigation, but the portion that is actively irrigated in that year, reflecting irrigation use, not potential capacity."
                    },
                    {
                        label: "Fertilizer use per area of cropland by nutrient",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["3102", "3103", "3104"],
                        id: 7,
                        uid: 72,
                        element_code: ["5159"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rfn',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The Fertilizers by Nutrient dataset contains information on the totals in nutrients for Production, Trade and Agriculture Use of inorganic (chemical or mineral) fertilizers, over the time series 1961-present. The data are provided for the three primary plant nutrients: nitrogen (N), phosphorus (expressed as P2O5) and potassium (expressed as K2O). Both straight and compound fertilizers are included."
                    },
                    {
                        label: "Fertilizer for agricultural use by nutrient",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["3102", "3103", "3104"],
                        id: 8,
                        uid: 73,
                        element_code: ["5157"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rfn',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The Fertilizers by Nutrient dataset contains information on the totals in nutrients for Production, Trade and Agriculture Use of inorganic (chemical or mineral) fertilizers, over the time series 1961-present. The data are provided for the three primary plant nutrients: nitrogen (N), phosphorus (expressed as P2O5) and potassium (expressed as K2O). Both straight and compound fertilizers are included."
                    },
                    {
                        label: "Fertilizer use per value of agricultural production by nutrient",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["3102", "3103", "3104"],
                        id: 9,
                        uid: 74,
                        element_code: ["5173"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rfn',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The Fertilizers by Nutrient dataset contains information on the totals in nutrients for Production, Trade and Agriculture Use of inorganic (chemical or mineral) fertilizers, over the time series 1961-present. The data are provided for the three primary plant nutrients: nitrogen (N), phosphorus (expressed as P2O5) and potassium (expressed as K2O). Both straight and compound fertilizers are included."
                    },
                    {
                        label: "Total pesticide's use per area of cropland",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["1357"],
                        id: 10,
                        uid: 75,
                        element_code: ["5159"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This is an indicator that expresses the intensity of pesticide application relative to the cropland area (arable land + permanent crops). It shows how many kilograms of pesticide active ingredients are applied, on average, per hectare of land that is cropped (whether irrigated or rainfed). Total pesticides cover insecticides, fungicides and bactericides (including seed treatments), herbicides, plant growth regulators, rodenticides, mineral oils, disinfectants and others.",
                    },
                    {
                        label: "Total agricultural use of pesticides",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["1357"],
                        id: 11,
                        uid: 76,
                        element_code: ["5157"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Total agricultural use of pesticides refers to the aggregate quantity of pesticide active ingredients used in the agricultural sector in a given year by a country. These pesticides include insecticides, herbicides, fungicides & bactericides, plant growth regulators, rodenticides, mineral oils, and other pesticide types. The measure is expressed in tonnes (metric tons) of active ingredient (i.e. excluding inert carriers).",
                    },
                    {
                        label: "Total pesticide's use per value of agricultural production",
                        subtheme: "1.2.1 Phytosanitary and agri-chemicals management (including pesticide and fertilisers)",
                        item_code: ["1357"],
                        id: 12,
                        uid: 77,
                        element_code: ["5173"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rp',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Total pesticide use per value of agricultural production (expressed as kg of active ingredient per unit of agricultural output value) is an intensity indicator that relates the volume of pesticide active ingredients used in agriculture to the monetary value of agricultural production (in constant international dollars). It reflects how many kilograms (or grams) of pesticide are used per thousand units of agricultural output value, thereby normalizing pesticide input relative to economic output.",
                    },
                    {
                        label: "Households using improved seeds, share of crop farm households (%)",
                        subtheme: "1.2.5 Seeds (e.g. penetration of modern varieties or GMO, etc.)",
                        indicator_code: ["ITC.H.ISU.PCT"],
                        id: 13,
                        uid: 78,
                        element_code: ["ITC"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator is the ratio of total number of crop farm households using improved seeds over the total number of crop farm households. Household weights are used in creating the totals, thus this indicator represents a share at the national level. The indicator on the use of improved seeds aims at capturing the level of technology and the access to improved inputs. This Indicator helps policy makers better target rural development policies aiming at filling the technological gap."
                    },
                    {
                        label: "Households using agricultural mechanical equipment (owned or rented), share of total farm households (%)",
                        subtheme: "1.2.3 Mechanization",
                        indicator_code: ["ITC.H.MEF.PCT"],
                        id: 14,
                        uid: 79,
                        element_code: ["ITC"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator is the ratio of the total number of crop farm households using mechanical equipment over the total crop farm households. Household weights are used in creating the totals, thus this indicator represents a share at the national level. Agricultural mechanization prompts higher output and increase the profitability of farm practices. It helps to save labor, reduce labor intensity, improve agricultural labour productivity . This indicator provides information on the extent of agricultural mechanization in the country and help policy makers better target rural development policies aiming at filling this gap."
                    },
                    {
                        label: "Share of livestock farm households covered by veterinarians or paraprofessionals (%)",
                        subtheme: "1.2.2 Veterinary services and medicines management",
                        indicator_code: ["L.H.VP.PCT"],
                        id: 15,
                        uid: 80,
                        element_code: ["L"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "It is measured as the ratio of the number of livestock farm households covered by veterinarians or paraprofessionals over the total number of livestock farm households. Households qualify for the indicator if they used veterinary services in the last 12 months. This information is important to understand the extent of access of livestock farm households to animal health and veterinary services. It indicates information about animal health, development of farming and accessibility of veterinary services in different regions and countries in the world."
                    },
                    {
                        label: "Share of livestock farm households with at least one animals vaccinated",
                        subtheme: "1.2.2 Veterinary services and medicines management",
                        indicator_code: ["L.H.AV.PCT"],
                        id: 16,
                        uid: 81,
                        element_code: ["L"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "It is measured as the ratio of the number of households that have at least one animal vaccinated over total number of livestock farm households. Household weights are used in creating the totals, thus this indicator represents a share at the national level. This information is important to understand the extent of access of livestock farm households to animal health and veterinary services. It indicates information about animal health, development of farming and accessibility to veterinary services in different regions and countries in the world."
                    },
                    {
                        label: "Quantity of products used as feed",
                        subtheme: "1.2.7 Origin and production of pre-farm gate inputs",
                        item_code: ["2905", "2907", "2908", "2909", "2911", "2913", "2914", "2918", "2919", "2922", "2943", "2945", "2946", "2948", "2960"],
                        id: 17,
                        uid: 82,
                        element_code: ["5521"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fbs',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Data refer to the quantity of the commodity in question available for feeding to the livestock and poultry during the reference period, whether domestically produced or imported."
                    },
                ]
            },
            {
                label: '1.4 Practices: Agricultural / fisheries / livestock',
                slug: 'practices-agricultural-fisheries-livestock',
                items: [
                    {
                        label: "SDG 14.6.1: International instruments to combat IUU fishing",
                        subtheme: "1.3.2 Other sustainable practices: Agroecology, Agroforestry; Nature based solutions; Sustainable fishing",
                        item_code: ["24030"],
                        id: 0,
                        uid: 83,
                        element_code: ["6173"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Degree of implementation of international instruments aiming to combat illegal, unreported and unregulated fishing. Legend: 1 Very low implementation of applicable instruments to combat IUU fishing; 2 Low implementation of applicable instruments to combat IUU fishing; 3 Medium implementation of applicable instruments to combat IUU fishing; 4 High implementation of applicable instruments to combat IUU fishing; 5 Very high implementation of applicable instruments to combat IUU fishing."
                    },
                    {
                        label: "Agriculture area under organic agric.",
                        subtheme: "1.3.1 Organic Agriculture",
                        item_code: ["6671", "6671"],
                        id: 1,
                        uid: 84,
                        element_code: ["5110", "7208"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'multipleAxis',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Agriculture area under organic agriculture refers to the land area (in hectares) that is managed under organic farming systems. Organic agriculture is defined as a production approach that excludes or largely restricts the use of synthetic fertilizers, synthetic pesticides, growth regulators, and genetically modified organisms, instead relying on ecological processes, biodiversity, and cycles adapted to local conditions.",
                    },
                    {
                        label: "Logistics Performance Index (LPI)",
                        subtheme: "1.4.3 Market infrastructure",
                        item_code: [],
                        id: 2,
                        uid: 85,
                        element_code: ["001"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_lpi',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                ]
            }
        ]
    },
    {
        value: 'improved-diets-nutrition-health',
        label: '2. Improved Diets, Nutrition and Health',
        indicators: [
            {
                label: '2.1 Food security and nutrition',
                slug: 'food-security-and-nutrition',
                items: [
                    {
                        label: "SDG 2.1.1: Undernourishment of total population",
                        subtheme: "2.1.1 Hunger and Food security",
                        item_code: ["24001", "24000"],
                        id: 0,
                        uid: 86,
                        element_code: ["6132", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'multipleAxis',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        isPoU: true,
                        // vw_sdgb now exposes a `unit` column and the chart prefers it; this
                        // stays as the fallback for the rows where it comes back empty.
                        unit_by_item: { "24000": "%", "24001": "Millions" },
                        header: "If the prevalence of undernourishment people is below 2.5%, then it is not shown in the figure. Consequently, the number of undernourished people is not reported. Also, if the number of undernourished people is <0.1 million then it is not shown in the figure.",
                        footer: "Country level data are three-year averages, and the year refers to the middle year of the three-year period. Subregional, regional and global averages are yearly data.",
                        description: "This indicator is an estimate of the proportion of the population whose habitual food consumption is insufficient to provide the dietary energy levels that are required to maintain a normal active and healthy life. It is expressed as a percentage."
                    },
                    {
                        label: 'SDG 2.1.2: Moderate or severe food insecurity of total population',
                        subtheme: "2.1.1 Hunger and Food security",
                        item_code: ["24005-_T-_T", "24002-TTT"],
                        id: 3,
                        uid: 88,
                        element_code: ["6199", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'multipleAxis',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        isFoodInsecurity: true,
                        unit_by_item: { "24005-_T-_T": "1000 No", "24002-TTT": "%" },
                        footer: "Country level data are three-year averages, and the year refers to the middle year of the three-year period. Subregional, regional and global averages are yearly data.",
                        header: "If the prevalence of moderate or severe food insecurity is below 0.5%, then it is not shown in the figure. Consequently, the number of moderately or severely food insecure people is not reported. Also, if the number of moderately or severely food insecure people is below 100 thousand, then it is not shown in the figure.",
                        description: "The indicator measures the percentage of individuals in the population who have experienced food insecurity at moderate or severe levels during the past 12 months. The severity of food insecurity, defined as a latent trait, is measured on the Food Insecurity Experience Scale global reference scale, a measurement standard established by FAO through the application of the Food Insecurity Experience Scale in more than 140 countries worldwide, starting in 2014. Moderate food insecurity: refers to the level of severity of food insecurity at which people face uncertainties about their ability to obtain food and have been forced to reduce, at times during the year, the quality and/or quantity of food they consume due to lack of money or other resources. It thus refers to a lack of consistent access to food, which diminishes dietary quality, disrupts normal eating patterns, and can have negative consequences for nutrition, health and well-being. Severe food insecurity: The level of severity of food insecurity at which people have likely run out of food, experienced hunger and, at the most extreme, gone for days without eating, putting their health and well-being at grave risk, based on the FIES."
                    },
                    {
                        label: 'SDG 2.1.2: Moderate or severe food insecurity by gender',
                        subtheme: "2.1.1 Hunger and Food security",
                        item_code: ["24002-MYGE15T", "24002-FYGE15T", "24005-M-Y_GE15", "24005-F-Y_GE15"],
                        id: 1,
                        uid: 87,
                        element_code: ["6121", "6121", "6199", "6199"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'multipleAxis',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        isFoodInsecurity: true,
                        useSideBySideBars: true,
                        unit_by_item: { "24002-MYGE15T": "%", "24002-FYGE15T": "%", "24005-M-Y_GE15": "1000 No", "24005-F-Y_GE15": "1000 No" },
                        header: "If the prevalence of moderate or severe food insecurity is below 0.5%, then it is not shown in the figure. Consequently, the number of moderately or severely food insecure people is not reported. Also, if the number of moderately or severely food insecure people is below 100 thousand, then it is not shown in the figure.",
                        footer: "Country level data are three-year averages, and the year refers to the middle year of the three-year period. Subregional, regional and global averages are yearly data.",
                        description: "Combined view of moderate and moderate or severe food insecurity by gender over a three-year average. Severe food insecurity is when people have likely run out of food, experienced hunger and, at the most extreme, gone for days without eating. Moderate food insecurity refers to reduced quality and/or quantity of food due to lack of resources. Estimates follow the Food Insecurity Experience Scale global reference scale."
                    },
                    // //
                    // {
                    //     label: 'SDG 2.1.2: Moderate food insecurity by gender (three-year average)',
                    //     item_code: ["24002-MYGE15T", "24002-FYGE15T"],
                    //     id: 1,
                    //     element_code: ["6121", "6121"],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_sdgb',
                    //     chart_type: 'barChart',
                    //     flag_sdg: 1,
                    //     trend_should: 'decrease',
                    //     compare_with_id: [],
                    //     isFoodInsecurity: true,
                    //     header: "If the prevalence of severe food insecurity below is 0.5%, then it is not shown in the figure. Consequently, the number of severely food insecure people is not reported. Also, if the number of severely food insecure people is <100 thousand then it is not shown in the figure.",
                    //     description: "The indicator measures the percentage of individuals in the population who have experienced food insecurity at moderate or severe levels during the past 12 months. The severity of food insecurity, defined as a latent trait, is measured on the Food Insecurity Experience Scale global reference scale, a measurement standard established by FAO through the application of the Food Insecurity Experience Scale in more than 140 countries worldwide, starting in 2014. Severe food insecurity: The level of severity of food insecurity at which people have likely run out of food, experienced hunger and, at the most extreme, gone for days without eating, putting their health and well-being at grave risk, based on the FIES  scale."
                    // },
                    // {
                    //     label: 'SDG 2.1.2: Moderate or severe food insecurity by gender (three-year average)',
                    //     item_code: ["24005-M-Y_GE15", "24005-F-Y_GE15"],
                    //     id: 2,
                    //     element_code: ["6199", "6199"],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_sdgb',
                    //     chart_type: 'barChart',
                    //     flag_sdg: 1,
                    //     trend_should: 'decrease',
                    //     compare_with_id: [],
                    //     isFoodInsecurity: true,
                    //     header: "If the prevalence of severe food insecurity below is 0.5%, then it is not shown in the figure. Consequently, the number of severely food insecure people is not reported. Also, if the number of severely food insecure people is <100 thousand then it is not shown in the figure.",
                    //     description: "The indicator measures the percentage of individuals in the population who have experienced food insecurity at moderate or severe levels during the past 12 months. The severity of food insecurity, defined as a latent trait, is measured on the Food Insecurity Experience Scale global reference scale, a measurement standard established by FAO through the application of the Food Insecurity Experience Scale in more than 140 countries worldwide, starting in 2014. Moderate food insecurity: refers to the level of severity of food insecurity at which people face uncertainties about their ability to obtain food and have been forced to reduce, at times during the year, the quality and/or quantity of food they consume due to lack of money or other resources. It thus refers to a lack of consistent access to food, which diminishes dietary quality, disrupts normal eating patterns, and can have negative consequences for nutrition, health and well-being. Severe food insecurity: The level of severity of food insecurity at which people have likely run out of food, experienced hunger and, at the most extreme, gone for days without eating, putting their health and well-being at grave risk, based on the FIES. Disaggregation: As the FIES or any other compatible experience-based food security questionnaire is applied through surveys, the prevalence of food insecurity can be measured in any population group for which the survey used to collect data is representative. If applied at household level, disaggregation is thus possible based on household characteristics such as location, household income, composition (including for example presence and number of small children, members with disabilities, elderly members, etc.), sex, age and education of the household head, etc. If applied at the individual level, proper disaggregation of the prevalence of food insecurity by sex is possible as the prevalence of food insecurity among male and among female members of the same population group can be measured independently. When producing disaggregated statistics, attention must be devoted to verifying the validity of the application by estimating the Rasch model with the data from each specific subpopulation group and, if necessary, perform the appropriate equating of the measure before comparing results. It is good practice to associate a measure of variability (margins of error or upper and lower bound) when disaggregated data are produced. At the moment, disaggregated statistics by gender of the respondent are provided."
                    // },
                    // //
                    {
                        label: 'SDG 2.1.2: Severe food insecurity of total population',
                        subtheme: "2.1.1 Hunger and Food security",
                        item_code: ["24004-_T-_T", "24003-TTT"],
                        id: 5,
                        uid: 90,
                        element_code: ["6199", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'multipleAxis',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        unit_by_item: { "24004-_T-_T": "1000 No", "24003-TTT": "%" },
                        header: "If the prevalence of severe food insecurity is below 0.5%, then it is not shown in the figure. Consequently, the number of severely food insecure people is not reported. Also, if the number of severely food insecure people is below 100 thousand, then it is not shown in the figure.",
                        footer: "Country level data are three-year averages, and the year refers to the middle year of the three-year period. Subregional, regional and global averages are yearly data.",
                        description: "Wasting results when a child falls significantly below the expected weight of a child of the same length or height. Wasting indicates current or acute undernutrition resulting from failure to gain expected weight or loss of weight. The main causes of wasting are inadequate food intake, inappropriate feeding practices, and infection or frequently a combination of all three factors. Definition : Children under 5 years who are wasted (moderate and severe). Percentage of wasted (moderate and severe) children aged 0–59 months (moderate = weightfor-height between <-2 and >-3 SD of the WHO Child Growth Standards median; severe = weight-for-height below -3 SD of the WHO Child Growth Standards median) METHOD OF ESTIMATION Numerator Number of children aged 0–59 months who are wasted. Denominator Total number of children aged 0–59 months who were measured.",
                    },
                    {
                        label: 'SDG 2.1.2: Severe food insecurity by gender',
                        subtheme: "2.1.1 Hunger and Food security",
                        item_code: ["24004-M-Y_GE15", "24004-F-Y_GE15", "24003-MYGE15T", "24003-FYGE15T"],
                        id: 4,
                        uid: 89,
                        element_code: ["6199", "6199", "6121", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'multipleAxis',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        isFoodInsecurity: true,
                        unit_by_item: { "24004-M-Y_GE15": "1000 No", "24004-F-Y_GE15": "1000 No", "24003-MYGE15T": "%", "24003-FYGE15T": "%" },
                        header: "If the prevalence of severe food insecurity below is 0.5%, then it is not shown in the figure. Consequently, the number of severely food insecure people is not reported. Also, if the number of severely food insecure people is <100 thousand then it is not shown in the figure.",
                        useSideBySideBars: true,
                        footer: "Country level data are three-year averages, and the year refers to the middle year of the three-year period. Subregional, regional and global averages are yearly data.",
                        description: "The indicator measures the percentage of individuals (female and male) in the population who have experienced food insecurity at moderate or severe levels during the past 12 months.  Severe food insecurity: The level of severity of food insecurity at which people have likely run out of food, experienced hunger and, at the most extreme, gone for days without eating, putting their health and well-being at grave risk, based on the FIES scale."
                    },
                    {
                        label: 'SDG 2.2.2: Percentage of children under 5 years of age who are stunted (percent)',
                        subtheme: "2.1.2 Nutritional status",
                        item_code: ["21025"],
                        id: 6,
                        uid: 91,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Definition Children under 5 years who are stunted (moderate and severe). Percentage of stunted (moderate and severe) children aged 0–59 months (moderate stunting = length/height-for-age between <-2 and >-3 SD of the WHO Child Growth Standards median; severe stunting = height-for-age below -3 SD of the WHO Child Growth Standards median) x under-five population at the time of the survey. METHOD OF ESTIMATION Numerator Number of children aged 0–59 months1 who were stunted. Denominator Total number of children aged 0–59 months who were measured.",
                    },
                    {
                        label: 'SDG 2.2.2: Percentage of children under 5 years of age who are overweight (percent)',
                        subtheme: "2.1.2 Nutritional status",
                        item_code: ["21041"],
                        id: 7,
                        uid: 92,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Overweight in children is reaching alarming proportions in many countries and poses an urgent and serious challenge. The prevalence of overweight among children is rapidly increasing even in many low- and middle-income countries. In 2016, at least 40.6 million children less than 5 years of age were overweight or obese, and most of them live in low- and middle-income countries (9). Progress in tackling childhood obesity has been slow and inconsistent. Definition Children aged under 5 years who are overweight. Prevalence of weight-for-height in children aged 0–59 months defined as above +2 SD of the WHO Child Growth Standards median. METHOD OF ESTIMATION Numerator: Number of children aged 0–59 months who are overweight. Denominator :Total number of children aged 0–59 months who were measured.",
                    },
                    {
                        label: 'Prevalence of obesity in the adult population (18 years and older)',
                        subtheme: "2.1.2 Nutritional status",
                        item_code: ["21042"],
                        id: 8,
                        uid: 93,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Adult obesity is defined as body mass index ≥30.0 kg/m2. The BMI is the weight-to-height ratio commonly used to classify the nutritional status of adults. It is calculated as the body weight in kilograms divided by the square of the body height in metres (kg/m2). Obesity includes individuals with BMI equal to or higher than 30 kg/m2. How it is reported Percentage of the population over 18 years of age with BMI ≥30.0 kg/m2 weighted by sex and standardized by age. The estimates presented are based on WHO (2024).44 The entire series of estimates is revised with every new update. Readers are advised to refrain from comparing the current series with prior updates.",
                    },
                    {
                        label: 'SDG 2.2.3: Prevalence of anemia among women of reproductive age (15-49 years)',
                        subtheme: "2.1.2 Nutritional status",
                        item_code: ["21043"],
                        id: 9,
                        uid: 94,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Definition: Percentage of women aged 15–49 years with a haemoglobin level less than 120 g/L for nonpregnant women and lactating women, and less than 110 g/L for pregnant women, adjusted for altitude and smoking. METHOD OF ESTIMATION Numerator : Number of women aged 15–49 years with haemoglobin levels below the indicated cut-off, adjusted for altitude and smoking. Denominator: For pregnant women Total number of women aged 15–49 years with haemoglobin levels assessed.",
                    },
                    {
                        label: 'Prevalence of exclusive breastfeeding among infants 0-5 months of age (percent)',
                        subtheme: "2.1.2 Nutritional status",
                        item_code: ["21044"],
                        id: 10,
                        uid: 95,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        food_group: '',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Breast milk provides optimal nutrition for a growing infant. Human milk contains adequate minerals and nutrients for the first six months of life. Breast milk also contains immune components, cellular elements and other host-defence factors that provide protection against infection. WHO recommends that breastfeeding should be initiated within the first hour of birth, infants should be exclusively breastfed during the first six months and continue breastfeeding for up to two years of age or beyond . Definition: Percentage of infants <6 months of age who are fed exclusively with breast milk METHOD OF ESTIMATION Numerator : Number of infants <6 months of age who are exclusively breastfed (meaning no other food or drink, including water). Denominator :Total number of infants <6 months of age surveyed.",
                    },
                    //   {
                    //     label: 'Food energy supply of all food groups',
                    //     item_code: ["4003"],
                    //     id: 11,
                    //     element_code: ["6128"],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_sua',
                    //     chart_type: 'stackedBar',
                    //     food_group: ["FG0"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: " This is an estimate of the per capita amount of energy (kcal) in food available for human consumption, which is sometimes confused with “effective food consumption”. Essentially, FBS estimates reflect the availability of food that is intended for human consumption and available for purchase at the point of sale. More appropriately, this is sometimes referred to as “apparent food consumption”. This differs from “effective food consumption”, that is, the actual quantity of food purchased or subsequently ingested by an identified group of individuals. "
                    //   },
                    //   {
                    //     label: 'Food energy supply of all food groups (excluding beverages)',
                    //     item_code: ["4003"],
                    //     id: 12,
                    //     element_code: ["6128"],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_sua',
                    //     chart_type: 'stackedBar',
                    //     food_group: ["FGD"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "The dataset presents average daily per capita macro and micro nutrient availability by country and by FAO/WHO GIFT food groups (that are different from those used for the Food Balance Sheets), expressed in grams/milligrams/micrograms/kcal per capita per day. The population numbers used to calculate these statistics can be found in the Supply Utilization Accounts (SUA) dataset of FAOSTAT, as Total Population. Food availability quantities are derived from the SUA dataset. SUAs present a comprehensive picture of the pattern of a country's food supply and utilization during a specified reference period."
                    //   },

                ]
            },
            {
                label: '2.2 Dietary Quality',
                slug: 'dietary-quality',
                items: [
                    {
                        label: "SDG 2.2.4.a: Minimum dietary diversity for infants and young children (%)",
                        subtheme: "2.2.2 Diversity of diet",
                        item_code: ["1"],
                        id: 44,
                        uid: 96,
                        element_code: ["222"],
                        // vw_unicef in the DWH project is empty (0 rows); the same UNICEF series
                        // - indicator_code 1 / element_code 222, children 6-23 months - is
                        // populated here instead, with 114 areas from 2005 on.
                        domain_code: 'fao-maps-review.fao_cca.mvw_unicef',
                        // area_code_m49 is a zero-padded STRING column in this view, as in the
                        // other fao-maps-review views, so the literal has to be quoted.
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                    },
                    {
                        label: 'SDG 2.2.4.b: Prevalence of minimum dietary diversity among non-pregnant women aged 15-49 years',
                        subtheme: "2.2.2 Diversity of diet",
                        // Read from the FAOSTAT SDG domain rather than the MDD-W one: the same
                        // measure is published there for 103 countries against the 23 survey
                        // countries MDD-W covers, which is why most countries showed nothing.
                        item_code: ["24049-F-Y15T49T"],
                        id: 43,
                        uid: 97,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Percentage of women of reproductive age (15 to 49 years old) consuming at least five out of ten defined food groups for the Minimum Dietary Diversity for Women (MDD-W) indicator the previous 24 hours.",
                    },
                    {
                        label: 'Energy supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4003"],
                        id: 0,
                        uid: 98,
                        element_code: ["6128"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        stacked_with_lines: true,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of dietary energy in kilocalories per capita per day."
                    },
                    {
                        label: 'Protein supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4004"],
                        id: 1,
                        uid: 99,
                        element_code: ["6123"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        stacked_with_lines: true,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of protein in grams per capita per day."
                    },
                    {
                        label: 'Fat supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4005"],
                        id: 2,
                        uid: 100,
                        element_code: ["6123"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of total fat in grams per capita per day."
                    },
                    {
                        label: 'Carbohydrate (available) supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4006"],
                        id: 3,
                        uid: 101,
                        element_code: ["6123"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of carbohydrates (excluding fibre) in grams per capita per day."
                    },
                    {
                        label: 'Dietary fibre supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4007"],
                        id: 4,
                        uid: 102,
                        element_code: ["6123"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of dietary total fibre in grams per capita per day."
                    },
                    // Removed: "additional nutrients for aquatic foods" dataset (FAOSTAT Food and Diets)
                    // {
                    //     label: 'Total saturated fatty acids supply by main food group',
                    //     calculate_residual: true,
                    //     residual_label: "Others",
                    //     item_code: ["4034"],
                    //     id: 5,
                    //     element_code: ["6123"],
                    //     domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                    //     chart_type: 'donut',
                    //     food_group: ["FG0", "FG6", "FG7", "FG11"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "Supply of total saturated fatty acids in grams per capita per day."
                    // },
                    // {
                    //     label: 'Total monounsaturated fatty acids supply by main food group',
                    //     calculate_residual: true,
                    //     residual_label: "Others",
                    //     item_code: ["4035"],
                    //     id: 6,
                    //     element_code: ["6123"],
                    //     domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                    //     chart_type: 'donut',
                    //     food_group: ["FG0", "FG6", "FG7", "FG11"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "Supply of total monounsaturated fatty acids in grams per capita per day."
                    // },
                    // {
                    //     label: 'Total polyunsaturated fatty acids supply by main food group',
                    //     calculate_residual: true,
                    //     residual_label: "Others",
                    //     item_code: ["4036"],
                    //     id: 7,
                    //     element_code: ["6123"],
                    //     domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                    //     chart_type: 'donut',
                    //     food_group: ["FG0", "FG6", "FG7", "FG11"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "Supply of total polyunsaturated fatty acids in grams per capita per day."
                    // },
                    // {
                    //     label: 'Eicosapentaenoic acid (EPA) supply by main food group',
                    //     calculate_residual: true,
                    //     residual_label: "Others",
                    //     item_code: ["4038"],
                    //     id: 8,
                    //     element_code: ["6123"],
                    //     domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                    //     chart_type: 'donut',
                    //     food_group: ["FG0", "FG6", "FG7", "FG11"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "Supply of eicosapentaenoic acid (EPA) in grams per capita per day."
                    // },
                    // {
                    //     label: 'Docosahexaenoic acid (DHA) supply by main food group',
                    //     calculate_residual: true,
                    //     residual_label: "Others",
                    //     item_code: ["4037"],
                    //     id: 9,
                    //     element_code: ["6123"],
                    //     domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                    //     chart_type: 'donut',
                    //     food_group: ["FG0", "FG6", "FG7", "FG11"],
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //     description: "Supply of docosahexaenoic acid (DHA) in grams per capita per day."
                    // },
                    {
                        label: 'Iron supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4010"],
                        id: 10,
                        uid: 103,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of iron in milligrams per capita per day."
                    },
                    {
                        label: 'Zinc supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4015"],
                        id: 11,
                        uid: 104,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of zinc in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin A supply (retinol activity equivalents) by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4018"],
                        id: 12,
                        uid: 105,
                        element_code: ["6206"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of vitamin A in micrograms of retinol activity equivalents per capita per day."
                    },
                    {
                        label: 'Vitamin A supply (retinol equivalents) by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4017"],
                        id: 13,
                        uid: 106,
                        element_code: ["6206"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of vitamin A in micrograms of retinol equivalents per capita per day."
                    },
                    {
                        label: 'Calcium supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4009"],
                        id: 15,
                        uid: 107,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of calcium in milligrams per capita per day."
                    },
                    {
                        label: 'Thiamin supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4021"],
                        id: 16,
                        uid: 108,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of thiamin in milligrams per capita per day."
                    },
                    {
                        label: 'Riboflavin supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4022"],
                        id: 17,
                        uid: 109,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of riboflavin in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin B6 supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4024"],
                        id: 18,
                        uid: 110,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG6", "FG7", "FG11"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of vitamin B6 in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin B12 supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4033"],
                        id: 19,
                        uid: 111,
                        element_code: ["6206"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG6", "FG7", "FG11"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of vitamin B12 in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin C supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4029"],
                        id: 20,
                        uid: 112,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of vitamin C in milligrams per capita per day."
                    },
                    {
                        label: 'Magnesium supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4011"],
                        id: 21,
                        uid: 113,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of magnesium in milligrams per capita per day."
                    },
                    {
                        label: 'Phosphorus supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4012"],
                        id: 22,
                        uid: 114,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of phosphorus in milligrams per capita per day."
                    },
                    {
                        label: 'Potassium supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4013"],
                        id: 23,
                        uid: 115,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of potassium in milligrams per capita per day."
                    },
                    {
                        label: 'Selenium supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4032"],
                        id: 24,
                        uid: 116,
                        element_code: ["6206"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG6", "FG7", "FG11"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of selenium in milligrams per capita per day."
                    },
                    {
                        label: 'Copper supply by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["4016"],
                        id: 25,
                        uid: 117,
                        element_code: ["6209"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sua',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG6", "FG7", "FG11"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Supply of copper in milligrams per capita per day."
                    },
                    {
                        label: 'Energy apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3302"],
                        id: 28,
                        uid: 118,
                        element_code: ["6128A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent dietary energy intake in kilocalories per capita per day."
                    },
                    {
                        label: 'Protein apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3303"],
                        id: 34,
                        uid: 119,
                        element_code: ["6123A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent protein intake in grams per capita per day."
                    },
                    {
                        label: 'Fat apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3304"],
                        id: 29,
                        uid: 120,
                        element_code: ["6123A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent total fat intake in grams per capita per day."
                    },
                    {
                        label: 'Carbohydrate (available) apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3305"],
                        id: 26,
                        uid: 121,
                        element_code: ["6123A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent carbohydrates intakes (excluding fibre) in grams per capita per day."
                    },
                    {
                        label: 'Dietary Fibre apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3306"],
                        id: 27,
                        uid: 122,
                        element_code: ["6123A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent dietary total fibre intake in grams per capita per day."
                    },
                    {
                        label: 'Iron apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3308"],
                        id: 30,
                        uid: 123,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent iron intake in milligrams per capita per day."
                    },
                    {
                        label: 'Zinc apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3312"],
                        id: 42,
                        uid: 124,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent zinc intake in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin A apparent intake (retinol activity equivalents) by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3318"],
                        id: 37,
                        uid: 125,
                        element_code: ["6206A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent vitamin A intake in micrograms of retinol activity equivalents per capita per day."
                    },
                    {
                        label: 'Vitamin A apparent intake (retinol equivalents) by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3319"],
                        id: 38,
                        uid: 126,
                        element_code: ["6206A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'stackedBar',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent vitamin A intake in micrograms of retinol equivalents per capita per day."
                    },
                    {
                        label: 'Calcium apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3307"],
                        id: 14,
                        uid: 127,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent calcium intake in milligrams per capita per day."
                    },
                    {
                        label: 'Thiamin apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3314"],
                        id: 36,
                        uid: 128,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent thiamin intake in milligrams per capita per day."
                    },
                    {
                        label: 'Riboflavin apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3315"],
                        id: 35,
                        uid: 129,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent riboflavin intake in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin B6 apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3316"],
                        id: 40,
                        uid: 130,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent vitamin B6 intake in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin B12 apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3317"],
                        id: 39,
                        uid: 131,
                        element_code: ["6206A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent vitamin B12 intake in milligrams per capita per day."
                    },
                    {
                        label: 'Vitamin C apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3313"],
                        id: 41,
                        uid: 132,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent vitamin C intake in milligrams per capita per day."
                    },
                    {
                        label: 'Magnesium apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3309"],
                        id: 31,
                        uid: 133,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent magnesium intake in milligrams per capita per day."
                    },
                    {
                        label: 'Phosphorus apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3310"],
                        id: 32,
                        uid: 134,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent phosphorus intake in milligrams per capita per day."
                    },
                    {
                        label: 'Potassium apparent intake by main food group',
                        subtheme: "2.2.2 Diversity of diet",
                        calculate_residual: true,
                        residual_label: "Others",
                        item_code: ["3311"],
                        id: 33,
                        uid: 135,
                        element_code: ["6209A"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_hces',
                        chart_type: 'donut',
                        food_group: ["FG0", "FG1", "FG2", "FG3", "FG4", "FG5", "FG6", "FG7", "FG9", "FG10", "FG11", "FG12", "FG14"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average apparent potassium intake in milligrams per capita per day."
                    }
                ]
            },
            {
                label: '2.3 Food and water safety',
                slug: 'food-and-water-safety',
                items: [
                    {
                        label: 'SDG 6.3.2: Proportion of bodies of water with good ambient water quality',
                        subtheme: "2.3.2. Water quality",
                        item_code: ["EN_H2O_WBAMBQ"],
                        id: 0,
                        uid: 136,
                        element_code: ['1'],
                        indicator_code: ["6.3.2"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_unsd',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        use_item_labels: true,
                        description: "The indicator tracks the percentage of water bodies (rivers, lakes and groundwater) in a country with good ambient water quality. “Good” indicates an ambient water quality that does not damage ecosystem function or human health according to core ambient water quality parameter groups that are relevant globally. For the purpose of global reporting (level 1 of the indicator), overall water quality is estimated based on an index, which incorporates data on five core parameter groups, which inform on major water quality impairments present in many parts of the world: oxygen (surface water). salinity (surface water and groundwater). nitrogen (surface water and groundwater). phosphorus (surface water). acidification (surface water and groundwater). The methodology calls for in-situ measurements of these water quality parameter groups. The measured values are compared to national target levels for the different parameters, and if values meet targets 80 per cent or more of the time, the water body is classified as good.",
                    },
                    {
                        label: 'SDG 6.1.1: Percentage of population using safely managed drinking water services (percent)',
                        subtheme: "2.3.2. Water quality",
                        item_code: ["21045"],
                        id: 1,
                        uid: 137,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Percentage of population whose drinking water comes from an improved water source which is located on premises, available when needed and free from faecal and priority chemical contamination.",
                    },
                ]
            },
            {
                label: '2.4 Food environments',
                slug: 'food-environments',
                items: [
                    {
                        label: "Cost of a healthy diet",
                        subtheme: "2.4.3 Economic Access to Food (Affordability)",
                        item_code: ["70040"],
                        id: 0,
                        uid: 138,
                        element_code: ["6226"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cahd',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The cost of a healthy diet is defined as the cost of purchasing the least expensive, locally available foods that may compose a diet that meets requirements for energy and food-based dietary guidelines (FBDGs) for a reference person within an energy balance set at 2 330 kcal per day. How it is reported: The indicator (denominated “cost of a healthy diet” [CoHD]) is an estimate of the average minimum cost that people must spend in a country to buy the least expensive, locally available foods needed to compose a healthy diet. For cross-country comparability, the cost of a healthy diet is converted from local currency units (LCU) to international dollars using purchasing power parity (PPP) exchange rates for private consumption. The CoHD indicator is thus reported as average PPP dollars per person per day.",
                    },
                    {
                        label: "Population unable to afford a healthy diet",
                        subtheme: "2.4.3 Economic Access to Food (Affordability)",
                        item_code: ["7006", "7005"],
                        id: 1,
                        uid: 139,
                        element_code: ["6132", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_cahd',
                        chart_type: 'multipleAxis',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        unit_by_item: { "7006": "Millions", "7005": "%" },
                        description: "The unaffordability of a healthy diet is defined as the inability of a household or of an individual to pay the amount of money needed to acquire the least-cost combination of locally available foods that meets the requirement for a healthy diet, after having accounted for the portion of their income they have to reserve for acquiring all basic needs other than food. How it is reported The main indicator (denominated “prevalence of unaffordability” [PUA]) is an estimate of the percentage of individuals in a population whose disposable income, net of the amount needed to acquire all basic non-food goods and services, is lower than the minimum cost of a healthy diet. National estimates are obtained by contrasting the country-specific income distributions against a threshold (r) obtained by summing the cost of a healthy diet with the relevant cost of basic non-food needs (n). Along with the PUA, the number of people unable to afford a healthy diet (NUA) is also computed by multiplying the PUA by the reference population size.",
                    },
                    {
                        label: "Food supply quantity",
                        subtheme: "2.4.2 Availability of healthy foods",
                        item_code: ["2905", "2918", "2919", "2943", "2949", "2948", "2960", "2961"],
                        id: 2,
                        uid: 140,
                        element_code: ["645"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fbs',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Food in the FBS definition refers to “all quantities available for human consumption, either direct by the producers, available for human consumption at the retail level or processed for food use.” (FAO, n.d.b). This variable (also called food availability or food supply) presents the amount of food reaching the retail level and therefore includes all waste and losses that occur at or after retail. Pag 11"
                    },
                    {
                        label: "Food supply (kcal/capita/day)",
                        subtheme: "2.4.2 Availability of healthy foods",
                        item_code: ["2905", "2918", "2919", "2943", "2949", "2948", "2960", "2961"],
                        id: 3,
                        uid: 141,
                        element_code: ["664"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fbs',
                        chart_type: 'line',
                        unit: "kcal/capita/day",
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "When analysing FBS, it is important to consider the definition of per capita dietary energy supply, i.e. the food supply (expressed in kcal/capita/day). This is an estimate of the per capita amount of energy (kcal) in food available for human consumption, which is sometimes confused with “effective food consumption”. Essentially, FBS estimates reflect the availability of food that is intended for human consumption and available for purchase at the point of sale. More appropriately, this is sometimes referred to as “apparent food consumption”. This differs from “effective food consumption”, that is, the actual quantity of food purchased or subsequently ingested by an identified group of individuals. Because FBS estimates do not account for food waste at the retail or household levels, incorrect interpretation would imply much higher and unrealistic levels of purchase and consumption. Pag 3"
                    },
                    {
                        label: "SDG 9.1.1: Rural access index",
                        subtheme: "2.4.1. Physical Access to Food (Food Entry Points and Built Environment)",
                        item_code: ["1"],
                        id: 4,
                        uid: 142,
                        element_code: ["UN_SDG_SP_ROD_R2KM"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_rai',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The Rural Access Index (RAI) measures the proportion of the rural population who live within 2 km of an all-season road. It is included in the Sustainable Development Goals as indicator 9.1.1., providing a way of measuring progress towards Goal 9 and Target 9.1. Originally developed by the World Bank in 2006, the RAI is among the most important global development indicators in the transport sector, providing a strong, clearly understandable and conceptually consistent indicator across countries. Although the underlying methodology has been recently updated to leverage additional sources of data, the RAI remains the most widely accepted metric for tracking access to transport in rural areas."
                    },
                    {
                        label: "Taxes on sugar-sweetened beverages",
                        subtheme: "2.2.1 Non-communicable diseases related to AFS",
                        item_code: [],
                        id: 5,
                        uid: 143,
                        element_code: ["73491442"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'status',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Reducing the affordability of sugar-sweetened beverages (SSBs) through the use of excise taxes is an effective tool to cut consumption. These beverages represent a significant source of free sugars and have been associated with the development of several non-communicable diseases (NCDs). While excise taxes have been primarily used to raise revenue, an increasing number of countries are now taxing SSBs to promote healthy diets. However, existing taxes differ widely in terms of design and level, and many are not optimized to achieve public health goals. Page vii",
                    },
                    {
                        label: "Availability of Food Based Dietary Guidelines (FBDGs)",
                        subtheme: "2.4.4. Political, Social, and Cultural Norms influencing dietary practices",
                        item_code: [],
                        id: 6,
                        uid: 144,
                        element_code: ["17006569"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'status',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Identifies which countries have adopted food-based dietary guidelines as part of their nutrition and public health strategies.",
                    },
                ]
            },
            {
                label: '2.5 Food waste & micronutrients food loss',
                slug: 'food-waste-micronutrients-food-loss',
                items: [
                    { // TODO: awaiting fix for standardizing the column names on the view
                        label: "SDG 12.3.1.b: Food waste per capita (KG)",
                        subtheme: "2.5.1 Food waste",
                        item_code: ["AG_FOOD_WST_PC"],
                        id: 0,
                        uid: 145,
                        element_code: ['12.3.1'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Indicator 12.3.1(b), the Food Waste Index, measures food and inedible parts wasted at the retail and consumer levels (household and food service). UNEP is its custodian. In contrast to the Food Loss Index, the Food Waste Index measures total food waste (rather than specific commodities). For this reason, the three sectors covered by the Food Waste Index are: food retail, food service and households. The Food Waste Index also allows countries to report on food loss in manufacturing that is not captured by the Food Loss Index (for example, where more than one commodity is combined to produce complex food products). This is an optional supplementary reporting area, a “Level 3” methodology (see later discussion). Wholesale food remains under the Food Loss Index and therefore should not be reported under the Food Waste Index.",
                    },
                ]
            },
        ]
    },
    {
        value: 'protected-environment-natural-resources',
        label: '3. Protected environment and natural resources',
        indicators: [
            {
                label: '3.1 Land',
                slug: 'land',
                items: [
                    {
                        label: "Land area",
                        subtheme: "3.1.1 Land Use and Expansion",
                        item_code: ["6610", "6646", "6670"],
                        id: 0,
                        uid: 146,
                        element_code: ["5110"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Agricultural land is land used for cultivation of crops and animal husbandry. The total of areas under ''Cropland'' and ''Permanent meadows and pastures.'' Forest land is land spanning more than 0.5 hectares with trees higher than 5 metres and a canopy cover of more than 10 per cent, or trees able to reach these thresholds in situ. Excludes land that is predominantly under agricultural or urban land use. Other land is land area not classified as \"Agriculture\" and ''Forestry''. It includes SEEA categories ''Land used for aquaculture\", ''Built-up and related areas\", ''Other uses of land not elsewhere classified\", and ''Land not in use\".",
                    },
                    {
                        label: "Agricultural land",
                        subtheme: "3.1.1 Land Use and Expansion",
                        item_code: ["6620", "6655"],
                        id: 1,
                        uid: 147,
                        element_code: ["5110"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The total of areas under “Land under temporary crops”, “Land under temporary meadows and pastures”, “Land with temporary fallow”, “Land under permanent crops”, “Land under permanent meadows and pastures”, and “Land under protective cover”. This category includes tilled and fallow land, and naturally grown permanent meadows and pastures used for grazing, animal feeding or agricultural purpose. Scattered land under farm buildings, yards and their annexes, and permanently uncultivated land, such as uncultivated patches, banks, footpaths, ditches, headlands and shoulders are traditionally included.",
                    },
                    {
                        label: "Agricultural land per capita",
                        subtheme: "3.1.1 Land Use and Expansion",
                        item_code: ["6620"],
                        id: 2,
                        uid: 148,
                        element_code: ["7277"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Total area of cropland and permanent meadows and pastures, divided by the total population, measured in hectares per person. This metric indicates the amount of agricultural land available to each person in a given country or region, reflecting the pressure on land resources for food production and other uses.",
                    },
                    {
                        label: "SDG 2.4.1: Proportion of agricultural land area that has achieved an acceptable or desirable level of soil degradation",
                        subtheme: "3.1.3 Soil quality (health) and Nutrient Management",
                        item_code: ["2404611"],
                        id: 3,
                        uid: 149,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The sub-indicator of SDG 2.4.1 (Proportion of agricultural areas under productive and sustainable agriculture) measures the extent to which agriculture activities affects soil health and therefore represents a sustainability issue. A review of the 10 threats to soil shows that all except one (soil sealing, which is the loss of natural soil to construction/urbanisation) are potentially and primarily affected by inappropriate agricultural practices. Ideally, therefore, all soils under agricultural land area in a country should be the subject of periodic monitoring in order to assess the impact of agriculture on soils."
                    },
                    {
                        label: "SDG 15.1.1: Forest area as a proportion of total land area",
                        subtheme: "3.1.1 Land Use and Expansion",
                        item_code: ["24034"],
                        id: 4,
                        uid: 150,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Forest area as percentage of total land area may be used as a rough proxy for the extent to which the forests in a country are being conserved or restored, but it is only partly a measure for the extent to which they are sustainably managed."
                    },
                    {
                        label: "SDG 15.4.2b: Mountain land degradation",
                        subtheme: "3.1.2 Land and Pasture quality management",
                        item_code: ["240103-_T"],
                        id: 5,
                        uid: 151,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Proportion of degraded mountain land, is designed to monitor the extent of degraded mountain land as a result of land cover change in a given country and for given reporting year. Similarly to sub-indicator ‘’trends in land cover” under SDG Indicator 15.3.1 (Sims et al. 2021), mountain ecosystem degradation and recovery is assessed based on the definition of land cover type transitions that indicate improving, stable or degrading conservation status. The definition of degradation adopted for the computation of this indicator is the one established Intergovernmental Science-Policy Platform on Biodiversity and Ecosystem Services (IPBES)"
                    },
                    {
                        label: "Nutrient balance",
                        subtheme: "3.1.3 Soil quality (health) and Nutrient Management",
                        item_code: ["5081"],
                        id: 6,
                        uid: 152,
                        element_code: ["7290"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_esb',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Nutrient balance is the difference between nutrient inputs into a farming system and nutrient outputs leaving the system. This difference is essentially the excess or deficit of nutrients in the system, with a positive balance indicating a surplus and a negative balance indicating a deficit."
                    },
                ]
            },
            {
                label: '3.2 Water (water stress and water pollution)',
                slug: 'water-usage-and-efficiency',
                items: [
                    {
                        label: "SDG 6.4.2: Level of water stress in agriculture",
                        subtheme: "3.2.1 Water stress",
                        item_code: ['4550'],
                        id: 0,
                        uid: 153,
                        element_code: ['102'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aqua',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The level of water stress in agriculture is the proportion of freshwater withdrawal by “agriculture; forestry; fishing (ISIC A)” (as defined by ISIC standards) over available freshwater resources, after considering environmental flow requirements. Legend: x ≤ 17.5 percent No stress; 17.5 < x ≤ 35 percent Low stress; 35 < x ≤ 52.5 percent Medium stress; 52.5 < x ≤ 70 percent High stress; x > 70 percent Critical stress."
                    }, {
                        label: "Marine eutrophication, total",
                        subtheme: "3.2.2 Water pollution",
                        item_code: [2, 1],
                        id: 1,
                        uid: 154,
                        element_code: [3],
                        domain_code: 'fao-dwh-review.fao_cca.vw_scp_hat',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Marine eutrophication is the process where excessive nutrients, mainly nitrogen and phosphorus from human activities, enrich coastal waters, leading to rapid algal and plant growth (algal blooms) that deplete dissolved oxygen, harming marine life and creating \"dead zones\". This nutrient over-enrichment stems from sources like agricultural runoff, urban wastewater, and industrial discharges, causing significant ecological and economic impacts on coastal ecosystems and fisheries"
                    }, {
                        label: "Marine eutrophication, per capita",
                        subtheme: "3.2.2 Water pollution",
                        item_code: [2, 1],
                        id: 2,
                        uid: 155,
                        element_code: [2],
                        domain_code: 'fao-dwh-review.fao_cca.vw_scp_hat',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The process of a marine ecosystem becoming overly enriched with nutrients (like nitrogen and phosphorus) due to human activities, leading to detrimental effects such as excessive algal growth, oxygen depletion, and harmful algal blooms. While per capita data can inform the discussion by showing human contributions of nutrients, the core definition of eutrophication describes the ecological response to excessive nutrients, not a measure per person."
                    }, {
                        label: "Marine eutrophication, per GDP",
                        subtheme: "3.2.2 Water pollution",
                        item_code: [2, 1],
                        id: 3,
                        uid: 156,
                        element_code: [1],
                        domain_code: 'fao-dwh-review.fao_cca.vw_scp_hat',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Marine eutrophication per GDP refers to the measure of how much economic activity (Gross Domestic Product) contributes to the negative environmental impact of marine eutrophication, or conversely, the economic impact of eutrophication on coastal GDP. It is a way to quantify the relationship between a nation's wealth and its contribution to or suffering from nutrient pollution in its marine ecosystems, which can lead to harmful algal blooms, dead zones, and loss of biodiversity."
                    },
                ]
            },
            {
                label: '3.3 Biosphere integrity and diversity',
                slug: 'biosphere-integrity-and-diversity',
                items: [
                    {
                        label: "SDG 15.1.2: Proportion of important sites for terrestrial and fresh water biodiversity that are covered by protected areas (%)",
                        subtheme: "3.3.1 Habitat protection",
                        item_code: ["ER_PTD_TERR", "ER_PTD_FRHWTR"],
                        id: 4,
                        uid: 161,
                        //element_code: [],
                        element_code: ['15.1.2'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "SDG 15.2.1: Annual forest area change rate",
                        subtheme: "3.3.2 Forest Health and Management",
                        // Reported on the five-year FRA cycle, so a reading covers the span since
                        // the previous assessment and the axis and tooltip show it as "2000-2015".
                        // Not set on the certification indicator below, which reports annually
                        // from 2015 on - there only the first point would carry a period.
                        reports_period: true,
                        unit: '%',
                        item_code: ["24037"],
                        id: 0,
                        uid: 157,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Annual forest area change rate defined as a percentage (%) of total forest area. Negative values indicate a net loss of forest, and positive values indicate a net gain."
                    },
                    {
                        label: "SDG 15.2.1: Forest area under an independently verified forest management certification scheme",
                        subtheme: "3.3.2 Forest Health and Management",
                        unit: '1000 ha',
                        item_code: ["24038"],
                        id: 1,
                        uid: 158,
                        element_code: ["6176"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Forest area certified under an independently verified certification scheme (in thousands of hectares). The area of forest, measured in hectares, which has been certified for sustainable use by and independently verified forest certification scheme."
                    },
                    {
                        label: "SDG 15.2.1: Proportion of forest area with a long-term management plan",
                        reports_period: true,
                        subtheme: "3.3.2 Forest Health and Management",
                        unit: '%',
                        item_code: ["24039"],
                        id: 2,
                        uid: 159,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Proportion o forest area with a long-term forest management plan defined as the basis for the sustainable management of forest resources. An increasing area under a forest management plan indicates progress towardssustainable forest management."
                    },
                    {
                        label: "SDG 15.2.1: Proportion of forest area within legally established protected areas",
                        reports_period: true,
                        subtheme: "3.3.2 Forest Health and Management",
                        unit: '%',
                        item_code: ["24040"],
                        id: 3,
                        uid: 160,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Share of forest area within legally established protected areas defined as a clearly defined geographical space, recognised, dedicated and managed, through legal or other effective means, to achieve the long-term conservation of naturewith associated ecosystem services and cultural values."
                    },
                    {
                        label: "SDG 15.2.1: Above-ground biomass in forest",
                        reports_period: true,
                        subtheme: "3.3.2 Forest Health and Management",
                        unit: 'tonnes/ha',
                        item_code: ["24036"],
                        id: 5,
                        uid: 162,
                        element_code: ["6177"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Above-ground biomass in forest is measured in tonnes per hectare. The total includes the preexisiting stocks of above-ground biomass plus the balance between gains from forest growth and losses due to wood removal,natural losses, fire, wind, pests and diseases."
                    },
                    {
                        label: "Deforestation and reforestation",
                        subtheme: "3.3.2 Forest Health and Management",
                        item_code: ["1"],
                        id: 6,
                        uid: 163,
                        element_code: ["0", "1"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_fra',
                        chart_type: 'barChart',
                        label_by_element: { "0": "Deforestation", "1": "Reforestation" },
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Deforestation is defined as the permanent conversion of forest land to other uses, regardless of whether it's human-induced or natural. Reforestation, on the other hand, is the re-establishment of forest cover on land that was previously forested, often through planting or natural regeneration."
                    }
                ]
            },
            {
                label: '3.4 Pollution and greenhouse gas emissions',
                slug: 'pollution-greenhouse-gas-emissions',
                items: [
                    {
                        label: "Agrifood systems total GHG emissions (CO2eq)(AR5)",
                        subtheme: "3.4.1 Greenhouse Gas Emissions management",
                        item_code: ["6996", "6516", "6517"],
                        id: 0,
                        uid: 164,
                        element_code: ["723113"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_gt',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Agrifood systems total GHG emissions indicator refers to all emissions generated throughout the food system, from farm production to consumption, and includes land-use change."
                    },
                    {
                        label: "Total emissions from crops, livestock and agricultural land",
                        subtheme: "3.4.1 Greenhouse Gas Emissions management",
                        item_code: ["6995", "5084", "5085"],
                        id: 1,
                        uid: 165,
                        element_code: ["723113"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_gt',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                    },
                    {
                        label: "Agrifood systems emissions share (CO2eq) (AR5)",
                        subtheme: "3.4.1 Greenhouse Gas Emissions management",
                        item_code: ["6518"],
                        id: 2,
                        uid: 166,
                        element_code: ["726313"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_em',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicators refers to the portion of total greenhouse gas (GHG) emissions that can be attributed to agrifood systems, expressed as a percentage of carbon dioxide equivalent (CO2eq) and calculated using the global warming potentials (GWPs) from the IPCC's Fifth Assessment Report (AR5)"
                    },
                    {
                        label: "Crop emissions intensity",
                        subtheme: "3.4.1 Greenhouse Gas Emissions management",
                        item_code: ["1718", "27"],
                        id: 3,
                        uid: 167,
                        element_code: ["71761"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ei',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Crop emission intensity refers to the amount of greenhouse gas (GHG) emissions produced per unit of a specific crop commodity. It essentially measures the efficiency of a crop's production process in terms of its environmental impact."
                    },
                    {
                        label: "Livestock emissions intensity",
                        subtheme: "3.4.1 Greenhouse Gas Emissions management",
                        item_code: ["867", "882", "947", "1017", "977", "1058", "1062", "1035"],
                        id: 4,
                        uid: 168,
                        element_code: ["71761"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ei',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Livestock emissions intensity is the mass of greenhouse gas (GHG) emissions per unit of product, such as kilograms of CO2eq per kilogram of meat, milk, or liveweight. This metric serves to compare the environmental impact of livestock activities by measuring the GHG emissions generated per unit of output, allowing for international comparisons of environmental performance across different countries and agricultural systems.",
                    },
                ]
            },
        ]
    },
    {
        value: 'improved-livelihoods-reduced-poverty',
        label: '4. Improved livelihoods, reduced poverty and inequality',
        indicators: [
            {
                label: '4.1 Employment and availability of human resources',
                slug: 'employment-availability-human-resources',
                items: [
                    {
                        label: "Crude rate of net migration",
                        subtheme: "4.1.3 Migration",
                        item_code: [],
                        id: 0,
                        uid: 169,
                        unit: "per 1,000 population",
                        element_code: ["4"],
                        item_code: ["66"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_unpd',
                        chart_type: 'line',
                        sex_code: ["3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the difference between the number of immigrants and emigrants per 1,000 population over a given period. A positive value indicates more people entering than leaving a country, while a negative value reflects net emigration. Used to measure the overall impact of migration on population change.",
                    },
                    {
                        label: "Total net migration",
                        subtheme: "4.1.3 Migration",
                        item_code: [],
                        id: 1,
                        uid: 170,
                        unit: "Persons",
                        element_code: ["4"],
                        item_code: ["65"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_unpd',
                        chart_type: 'line',
                        sex_code: ["3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator is the combined count of all individuals who have moved into or out of a country during a specified period, encompassing both immigration and emigration.",
                    },
                    {
                        label: "Personal remittances, received (% of GDP)",
                        subtheme: "4.1.3 Migration",
                        item_code: ["BX.TRF.PWKR.DT.GD.ZS"],
                        element_code: [],
                        id: 2,
                        uid: 171,
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator refers to the total inflow of personal remittances received by a country, expressed as a percentage of GDP. Personal remittances comprise personal transfers and compensation of employees. Personal transfers consist of all current transfers in cash or in kind made or received by resident households to or from nonresident households, while compensation of employees covers income earned by border, seasonal, and other short-term workers employed outside their country of residence.",
                    },
                    {
                        label: "Employment in agriculture - ILO modelled estimates",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21144"],
                        id: 3,
                        uid: 172,
                        element_code: ["6199"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'barChart',
                        sex_code: ["2", "3", "1"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the number of people employed in agriculture sector. Employment is defined as persons of working age who were engaged in any activity to produce goods or provide services for pay or profit, whether at work during the reference period or not at work due to temporary absence from a job, or to working-time arrangement. The agriculture sector consists of activities in agriculture, hunting, forestry and fishing, in accordance with division 1 (ISIC 2) or categories A-B (ISIC 3) or category A (ISIC 4)."
                    },
                    {
                        label: "Share of employment in agriculture in total employment - ILO Modelled Estimates",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21156"],
                        id: 4,
                        uid: 173,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'barChart',
                        sex_code: ["2", "3", "1"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator gives the share of people employed in agriculture sector among the total employed population. Employment is defined as persons of working age who were engaged in any activity to produce goods or provide services for pay or profit, whether at work during the reference period or not at work due to temporary absence from a job, or to working-time arrangement. The agriculture sector consists of activities in agriculture, hunting, forestry and fishing, in accordance with division 1 (ISIC 2) or categories A-B (ISIC 3) or category A (ISIC 4)."
                    },
                    {
                        label: "Employment in agrifood systems - total number and share in total employment",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21160", "21161"],
                        id: 5,
                        uid: 174,
                        element_code: ["6199", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'multipleAxis',
                        unit_by_item: { "21160": "1000 No", "21161": "%" },
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the total number of people employed in agrifood systems and its share relative to total employment. Davis et. al. 2023 defines agrifood systems as \"encompass[ing] primary agricultural production of food and non-food products (from crops, livestock, fisheries, forestry and aquaculture), the production of food of non-agricultural origin (e.g. synthetic meat), the food supply chain from producers to consumers, and the final consumption or disposal (waste) of food\".",
                    },
                    {
                        label: "Non-agricultural AFS employment - total number and share in total employment",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21163", "21167"],
                        id: 6,
                        uid: 175,
                        element_code: ["6199", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'multipleAxis',
                        unit_by_item: { "21163": "1000 No", "21167": "%" },
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator referes to the component of agrifood system employment that is not in primary agriculture.",
                    },
                    {
                        label: "Total AFS employment by sector",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21162", "21164"],
                        id: 7,
                        uid: 176,
                        // The view carries Total, Male and Female: without choosing, all three land on the
                        // same year with different values and nothing is drawn.
                        sex_code: ["1"],
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to the breakdown of AFS employment by sub-sector.",
                    },
                    {
                        label: "Total rural employment",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        //item_code: [],
                        item_code: ["21087"],
                        id: 8,
                        uid: 177,
                        element_code: ["6199"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oer',
                        chart_type: 'barChart',
                        sex_code: ["2", "3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator refers to all persons of working age in rural areas who during a specified brief period, such as one week or one day, were in the following categories: a) paid employment (whether at work or with a job but not at work) or b) self-employment (whether at work or with an enterprise but not at work) in agriculture, forestry and fishing."
                    },
                    {
                        label: "Youth employment in agriculture",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21088"],
                        id: 9,
                        uid: 178,
                        element_code: ["6199"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'barChart',
                        sex_code: ["2", "3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator refers to youth who during a specified brief period, such as one week or one day, were in the following categories: a) paid employment (whether at work or with a job but not at work) or b) self-employment (whether at work or with an enterprise but not at work) in agriculture, forestry and fishing."
                    },
                    {
                        label: "Youth rural employment",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        //item_code: [],
                        item_code: ["21094"],
                        id: 10,
                        uid: 179,
                        element_code: ["6199"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oer',
                        chart_type: 'barChart',
                        sex_code: ["2", "3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator refers to youth in rural areas who during a specified brief period, such as one week or one day, were in the following categories: a) paid employment (whether at work or with a job but not at work) or b) self-employment (whether at work or with an enterprise but not at work) in agriculture, forestry and fishing."
                    },
                    {
                        label: "Share of AFS employment in total employment",
                        subtheme: "4.1.1 Rural and Agrifood System Employment in the country:",
                        item_code: ["21161"],
                        id: 11,
                        uid: 180,
                        // The view carries Total, Male and Female: without choosing, all three land on the
                        // same year with different values and nothing is drawn.
                        sex_code: ["1"],
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_oea',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator gives the share of agrifood system employment in total employment."
                    },
                    {
                        label: "Unemployment, total (% of total labor force) (modeled ILO estimate)",
                        item_code: ["SL.UEM.TOTL.ZS"],
                        element_code: [],
                        id: 12,
                        uid: 181,
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The unemployment rate is the share of persons who are unemployed as a percent of the labour force. The unemployed comprise all persons of working age who were: a) without work during the reference period, i.e. were not in paid employment or self-employment; b) currently available for work, i.e. were available for paid employment or self-employment during the reference period; and c) seeking work, i.e. had taken specific steps in a specified recent period to seek paid employment or self-employment. The labour force is the sum of all persons of working age who are employed and those who are unemployed.",
                    },
                ]
            },
            {
                label: '4.2 Access to essential infrastructure and services',
                slug: 'access-essential-infrastructure-and-services',
                items: [
                    {
                        label: "SDG 7.1.1: Access to electricity",
                        subtheme: "4.2.1 Access to basic infrastructure, incl. energy supply (e.g. electricity), communication networks (e.g. roads and other means of transportation, internet, mobile phones)",
                        item_code: ["EG.ELC.ACCS.ZS", "EG.ELC.ACCS.UR.ZS", "EG.ELC.ACCS.RU.ZS"],
                        id: 0,
                        uid: 182,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Proportion of population with access to electricity is the percentage of population with access to electricity. Electricity access in this scenario refers to the proportion of population in the considered area (country, region, and global context) that has access to consistent sources of electricity.",
                    },
                    {
                        label: "SDG 3.8.1 Universal health coverage (UHC) service coverage index",
                        subtheme: "4.2.2 Access to basic service, incl. health, education",
                        item_code: ["SH.UHC.SCI"],
                        id: 1,
                        uid: 183,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Proportion of population with access to electricity is the percentage of population with access to electricity. Electricity access in this scenario refers to the proportion of population in the considered area (country, region, and global context) that has access to consistent sources of electricity.",
                    },
                    {
                        label: "Mean years of schooling (ISCED 1 or higher), population 25+ years, both sexes and by sex",
                        subtheme: "4.1.2 Availability of human resources (quantitity ) and adapted skills (quality)",
                        item_code: ["MYS.1T8.AG25T99.M", "MYS.1T8.AG25T99.F", "MYS.1T8.AG25T99"],
                        id: 2,
                        uid: 184,
                        element_code: ["MYS.1T8.AG25T99.M", "MYS.1T8.AG25T99.F", "MYS.1T8.AG25T99"],
                        // The UNESCO views carry no `item` column, so without this the legend would
                        // fall back to the raw codes. Wording taken from the views' own `sex` column.
                        label_by_item: { "MYS.1T8.AG25T99.M": "Males", "MYS.1T8.AG25T99.F": "Females", "MYS.1T8.AG25T99": "Total" },
                        domain_code: 'fao-dwh-review.fao_cca.vw_unesco_opri',
                        chart_type: 'barChart',
                        sex_code: ["1", "2", "3"],
                        label_by_item: { "MYS.1T8.AG25T99.M": "Male", "MYS.1T8.AG25T99.F": "Female", "MYS.1T8.AG25T99": "Total" },
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average number of completed years of education of a country's population aged 25 years and older, excluding years spent repeating individual grades.",
                    },
                    {
                        label: "Mobile cellular subscriptions (Number per 100 people) ",
                        subtheme: "4.2.1 Access to basic infrastructure, incl. energy supply (e.g. electricity), communication networks (e.g. roads and other means of transportation, internet, mobile phones)",
                        item_code: ["IT.CEL.SETS"],
                        id: 3,
                        uid: 185,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        //sex_code: ["1", "2", "3"],
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Mobile cellular telephone subscriptions are subscriptions to a public mobile telephone service that provide access to the PSTN using cellular technology. The indicator includes (and is split into) the number of postpaid subscriptions, and the number of active prepaid accounts (i.e. that have been used during the last three months). The indicator applies to all mobile cellular subscriptions that offer voice communications. It excludes subscriptions via data cards or USB modems, subscriptions to public mobile data services, private trunked mobile radio, telepoint, radio paging and telemetry services.",
                    }
                ]
            },
            {
                label: '4.3 Poverty and inequality',
                slug: 'poverty-and-inequality',
                items: [
                    {
                        label: "SDG 10.4.2: Gini index (income)",
                        subtheme: "4.3.2 Earnings and Income Inequality",
                        item_code: ["SI.POV.GINI"],
                        id: 0,
                        uid: 186,
                        element_code: [""],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Gini index measures the extent to which the distribution of income (or, in some cases, consumption expenditure) among individuals or households within an economy deviates from a perfectly equal distribution. A Gini index of 0 represents perfect equality, while an index of 100 implies perfect inequality.",
                    },
                    {
                        label: "SDG 1.1.1: Poverty headcount ratio at international poverty lines",
                        subtheme: "4.3.1 Poverty",
                        item_code: ["SI.POV.DDAY", "SI.POV.LMIC", "SI.POV.UMIC"],
                        id: 1,
                        uid: 187,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Poverty headcount ratio is the percentage of the population living on less than $3.2/$4.2/$8.3 at 2021 purchasing power adjusted prices. As a result of revisions in PPP exchange rates, poverty rates for individual countries cannot be compared with poverty rates reported in earlier editions.",
                    },
                    {
                        label: "SDG 2.3.2: Average income of food producers by scale by sex",
                        subtheme: "4.3.2 Earnings and Income Inequality",
                        item_code: ["24008-M", "24008-F", "24008-_T", "24009-F", "24009-M", "24009-_T"],
                        id: 2,
                        uid: 188,
                        element_code: ["6174", "61741"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        sort_by_item: true,
                        unit: "Constant PPP 2017 USD/year",
                        description: "SDG indicator 2.3.2 measures income from on-farm production activities, which is related to the production of food and agricultural products. This includes income from crop production, livestock production, fisheries and aquaculture production, and from forestry production. The indicator is computed as annual income.",
                    },
                    {
                        label: "SDG 1.3.1: Social protection coverage",
                        subtheme: "4.3.4 Social protection",
                        item_code: ["SI_COV_BENFTS"],
                        id: 3,
                        uid: 189,
                        element_code: ["1.3.1"],
                        sex: ["Both sexes"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: ""
                    },
                    {
                        label: "Adequacy of benefits (%) - All social protection and labour",
                        subtheme: "4.3.4 Social protection",
                        item_code: ["per_allsp.adq_pop_tot"],
                        id: 4,
                        uid: 190,
                        unit: "%",
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_aspire',
                        chart_type: 'line',
                        // Not an SDG series: the global SDG database has no adequacy measure under
                        // 1.3.1, only coverage ones, so the SDG badge would misattribute a World
                        // Bank figure. The title never claimed SDG either.
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Sourced from the World Bank's ASPIRE (Atlas of Social Protection Indicators of Resilience and Equity) database, item code per_allsp.adq_pop_tot: total transfer amount received by all beneficiaries in a population group, expressed as a share of the total welfare (income or consumption) of beneficiary households, across all social protection and labor programs combined. Related to SDG 1.3.1 as a measure of benefit adequacy rather than coverage."
                    },
                    {
                        label: "Area of holdings by land size",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270030", "270031", "270032", "270033", "270034", "270035", "270036", "270037", "270038", "270039", "2700300", "2700301", "2700302", "2700303", "2700304", "2700305"],
                        id: 5,
                        uid: 191,
                        element_code: ["50260"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total area of holdings classified according to different land size categories. According to WCA 2020 ''An agricultural holding is an economic unit of agricultural production under single management comprising all livestock kept, and all land used wholly or partly for agricultural production purposes''. However, countries may apply their own definitions of agricultural holdings, which could affect the international comparability of census data.",
                    },
                    {
                        label: "Number of holdings by land size",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270030", "270031", "270032", "270033", "270034", "270035", "270036", "270037", "270038", "270039", "2700300", "2700301", "2700302", "2700303", "2700304", "2700305"],
                        id: 6,
                        uid: 192,
                        element_code: ["60850"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total number of holdings classified according to different land size categories. According to WCA 2020 ''An agricultural holding is an economic unit of agricultural production under single management comprising all livestock kept, and all land used wholly or partly for agricultural production purposes''. However, countries may apply their own definitions of agricultural holdings, which could affect the international comparability of census data.",
                    },
                    {
                        label: "Area of holdings by legal status",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270070", "270071", "270072"],
                        id: 7,
                        uid: 193,
                        element_code: ["50260"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total area of holdings classified according to legal status. WCA 2020 defines legal status as \"juridical aspects under which an agricultural holding is operated\".",
                    },
                    {
                        label: "Number of holdings by legal status",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270070", "270071", "270072"],
                        id: 8,
                        uid: 194,
                        element_code: ["60850"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total number of holdings classified according to legal status. WCA 2020 defines legal status as \"juridical aspects under which an agricultural holding is operated\".",
                    },
                    {
                        label: "Area of holdings by tenure",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270060", "270061", "270062"],
                        id: 9,
                        uid: 195,
                        element_code: ["50260"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total area of holdings classified according to land tenure. WCA defines tenure as \"arrangements or rights under which the holder operates the land making up the holding\".",
                    },
                    {
                        label: "Number of holdings by tenure",
                        subtheme: "4.3.3 Landholdings structure and tenure rights",
                        item_code: ["270060", "270061", "270062", "270064"],
                        id: 10,
                        uid: 196,
                        element_code: ["60850"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'stackedBar',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator refers to total area of holdings classified according to land tenure. WCA defines tenure as \"arrangements or rights under which the holder operates the land making up the holding\".",
                    },
                    {
                        label: "Average daily wages in agricultural sector",
                        subtheme: "4.3.2 Earnings and Income Inequality",
                        indicator_code: ["IP.I.ADWA.PPP"],
                        id: 11,
                        uid: 197,
                        element_code: ["IP"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Average daily earnings in agriculture, forestry, fishery"
                    },
                ]
            }
        ]
    },
    {
        value: 'increased-resilience',
        label: '5. Increased resilience',
        indicators: [
            {
                label: '5.1 Exposure to shocks',
                slug: 'exposure-to-shocks',
                items: [
                    {
                        label: "SDG 2.c.1: Indicator of Food Price Anomalies (IFPA), by Food CPI",
                        subtheme: "5.1.2 Economic shocks/ stresses",
                        item_code: ["24025"],
                        id: 0,
                        uid: 198,
                        unit: "Index",
                        element_code: ["6125"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The indicator of food price anomalies (IFPA) identifies markets prices that are abnormally high. The IFPA relies on a weighted compound growth rate that accounts for both within year and across year price growth. The indicator directly evaluates growth in prices over a particular month over many years, taking into account seasonality in agricultural markets and inflation, allowing us to answer the question of whether or not a change in price is abnormal for any particular period. Legend: IFPAy < 0.5 Normal food price change; 0.5 ≤ IFPAy < 1 Moderately high food price change; IFPAy ≥ 1 Abnormally high food price change."
                    },
                    {
                        label: "Temperature change on land (Annual Mean Temperature / Meteorological year)",
                        unit: '°C above 1951-1980 baseline',
                        subtheme: "5.1.1 Environmental and climate stresses (droughts and flooding, typhoons/cyclones or natural disasters etc)",
                        item_code: ["7020"],
                        id: 1,
                        uid: 199,
                        element_code: ["7271"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_et',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This indicator refers to the mean surface temperature change, i.e., temperature change with respect to a baseline climatology, corresponding to the period 1951–1980. Data are based on the publicly available GISTEMP data, the Global Surface Temperature Change data distributed by the National Aeronautics and Space Administration Goddard Institute for Space Studies (NASA-GISS)."
                    },
                    {
                        label: "Agricultural Stress Index",
                        subtheme: "5.1.1 Environmental and climate stresses (droughts and flooding, typhoons/cyclones or natural disasters etc)",
                        item_code: [1, 2],
                        id: 2,
                        uid: 200,
                        element_code: [1],
                        // CHANGE IT!
                        domain_code: 'fao-maps-review.fao_cca.mvw_giews_asi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Measures the share (%) of arable/cropped land within an administrative area that, over the entire crop season, showed vegetation stress consistent with agricultural drought. Higher values indicate a larger portion of cropland under water-stress conditions; lower values indicate limited affected area. The annual summary is produced from FAO’s ASIS by integrating the Vegetation Health Index (VHI) across the season and aggregating stressed pixels (∼1 km input) to administrative units; it differs from the near-real-time/dekadal ASI, which reflects conditions up to the current dekad rather than the full season.",
                    },
                    {
                        label: "Per capita food supply variability (kcal/cap/day)",
                        item_code: ["21031"],
                        id: 3,
                        uid: 201,
                        element_code: ["6128"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fs',
                        chart_type: 'line',
                        unit: "kcal/capita/day",
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This metric monitors the fluctuations in the average daily caloric supply accessible to individuals over a specific period, serving as an indicator of the stability and reliability of food availability in a region. Notable variability in this indicator may indicate potential food insecurity, particularly in situations where drought conditions disrupt agricultural productivity and food supply chains. By tracking this variability, it is possible to identify populations at risk of food shortages during periods of diminished agricultural output due to drought. It also assists in the development of effective strategies to stabilize food supplies, such as improving food storage facilities, diversifying food sources, and enhancing agricultural resilience to environmental stresses. Understanding per capita food supply variability is thus essential for thorough drought risk management and strategic planning.",
                    },
                    {
                        label: "Annual displacement by conflicts and by disasters",
                        subtheme: "5.1.3 Conflict/ political unrest",
                        item_code: [],
                        id: 4,
                        uid: 202,
                        unit: "Number of displacements",
                        element_code: [5, 1],
                        domain_code: 'fao-dwh-review.fao_cca.vw_idmc',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This metric tracks the number of new internal displacements recorded within a year, disaggregated by conflict/violence and by disasters. It reflects the scale and intensity of population movements triggered by acute shocks: higher values signal larger or more frequent displacement events and rising pressure on services, livelihoods, and food systems.",
                    },
                    // TODO: view has duplicates for this indicator, tested belarus with full year range
                    {
                        label: "SDG 1.5.2 Direct agriculture loss attributed to disasters (current United States dollars)",
                        subtheme: "5.1.1 Environmental and climate stresses (droughts and flooding, typhoons/cyclones or natural disasters etc)",
                        item_code: ["VC_DSR_AGLH"],
                        id: 5,
                        uid: 203,
                        element_code: ["1.5.2"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                    },
                ]
            },
            {
                label: '5.2 Resilience capacities',
                slug: 'resilience-capacities',
                items: [
                    {
                        label: "2.5.1a: Number of plant genetic resources for food and agriculture secured in either medium or long term conservation facilities",
                        subtheme: "5.2.3 Agrodiversity (proxies production resilience)",
                        item_code: ["ER_GRF_PLNTSTOR"],
                        id: 0,
                        uid: 204,
                        //element_code: [],
                        element_code: ["2.5.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                    },
                    {
                        label: "2.5.1b: Number of animal genetic resources for food and agriculture secured in either medium or long term conservation facilities",
                        subtheme: "5.2.3 Agrodiversity (proxies production resilience)",
                        item_code: ["ER_GRF_ANIMKPT", "ER_GRF_ANIMRCNTN", "ER_GRF_ANIMRCNTN_TRB", "ER_GRF_ANIMKPT_TRB"],
                        id: 1,
                        uid: 205,
                        // element_code: [],
                        element_code: ["2.5.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'decrease',
                        compare_with_id: [],
                    },
                    {
                        label: "SDG 2.5.2: Proportion of local and transboundary breeds classified as being at risk of extinction",
                        subtheme: "5.2.3 Agrodiversity (proxies production resilience)",
                        item_code: ["ER_RSK_LBREDS", "ER_RSK_TRBBREDS"],
                        id: 2,
                        uid: 206,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        use_item_labels: true,
                    },
                    {
                        label: "Dietary sourcing flexibility index (total sources for calories)",
                        subtheme: "5.2.2 Food Diversity (proxies food supply resilience)",
                        item_code: [],
                        id: 3,
                        uid: 207,
                        unit: "Index (0-1)",
                        element_code: ['20787497'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                    },
                    {
                        label: "Enrolled in the International FAO Antimicrobial Resistance Monitoring System (InFARM)",
                        subtheme: "5.2.1 Animal and plant health surveillance, early warning and protection systems",
                        item_code: ['001'],
                        id: 4,
                        uid: 208,
                        element_code: ['001'],
                        domain_code: 'fao-dwh-review.fao_cca.vw_infarm',
                        chart_type: 'status',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "This metric indicates whether a country is formally enrolled in FAO’s InFARM system, the global platform that helps countries generate, analyze and share AMR data in animals and food. “Enrolled” reflects that national focal points have been identified and an enrolment request has been submitted and accepted, granting access to the InFARM IT platform and related questionnaires and workflows for data submission. Interpretation: enrollment signals a country’s institutional engagement and readiness to participate in AMR surveillance in agrifood systems and to share data at chosen confidentiality levels; it does not by itself imply the availability, quality, or volume of submitted AMR data.",
                    },
                ]
            },
        ]
    },
    {
        value: 'better-means-of-implementation',
        label: '6. Better means of implementation',
        indicators: [
            {
                label: '6.1. Rights',
                slug: 'rights',
                items: [
                    {
                        label: "Gender inequality index",
                        item_code: [],
                        id: 0,
                        uid: 209,
                        unit: "Index (0-1)",
                        element_code: ["31079458"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator reflects gender-based disadvantage in three dimensions—reproductive health, empowerment, and the labor market—for as many countries as data of reasonable quality allow. It shows the loss in potential human development due to inequality between female and male achievements in these dimensions. It ranges from 0, where women and men fare equally, to 1, where one gender fares as poorly as possible in all measured dimensions."
                    },
                    {
                        label: "SDG 10.3.1: Proportion of population reporting having personally felt discriminated against or harassed in the previous 12 months on the basis of a ground of discrimination prohibited under international human rights law",
                        subtheme: "6.1.1 Rights of women, children, youth, indigenous groups and other vulnerable groups",
                        item_code: ["VC_VOV_GDSD"],
                        id: 1,
                        uid: 210,
                        element_code: ["10.3.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator is defined as the proportion of the population (adults) who self-report that they personally experienced discrimination or harassment during the last 12 months based on ground(s) prohibited by international human rights law (IHRL). IHRL refers to the body of international legal instruments aiming to promote and protect human rights, including the Universal Declaration of Human Rights (UDHR) and sub sequent international human rights treaties adopted by the United Nations (UN). Concepts: Discrimination is any distinction, exclusion, restriction or preference or other differential treatment that is directly or indirectly based on prohibited grounds of discrimination, and which has the intention or ef fect of nullifying or impairing the recognition, enjoyment or exercise, on an equal footing, of human rights and fundamental freedoms in the political, economic, social, cultural or any other field of public life.1 Harassment is a form of discrimination when it is also based on prohibited grounds of discrimina tion. Harassment may take the form of words, gestures or actions, which tend to annoy, alarm, abuse, demean, intimidate, belittle, humiliate or embarrass another or which create an intimidating, hostile or offensive environment. While generally involving a pattern of behaviours, harassment can take the form of a single incident. IHRL provides lists of the prohibited grounds of discrimination. The inclusion of “other status” in these lists indicate that they are not exhaustive and that other grounds may be recognized by international hu man rights mechanisms. A review of the international human rights normative framework helps identify a list of grounds that includes race, colour, sex, language, religion, political or other opinion, national origin, social origin, property, birth status, disability, age, nationality, marital and family status, sexual orientation, gender identity, health status, place of residence, economic and social situation, pregnancy, indigenous status, afro-descent and other status.3 In practice, it will be difficult to include all potentially relevant grounds of discrimination in household survey questions. For this reason, it is recommended that data collectors identify contextually relevant and feasible lists of grounds, drawing on the illustrative list and formulation of prohibited grounds of discrimination outlined in the methodology section below, and add an “other” category to reflect other grounds that may not have been listed explicitly."
                    },
                    {
                        label: "SDG 5.a.1.a: Proportion of people with ownership or secure rights over agricultural land, by sex",
                        subtheme: "6.1.2 Mainstreaming gender equality, child protection, empowerment, and fairness",
                        item_code: ["24042-_T", "24042-F", "24042-M"],
                        id: 2,
                        uid: 211,
                        element_code: ["6121", "6121", "6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Sub-indicator 5.a.1 (a) is a prevalence measure. It measures the prevalence of people in the agricultural population with ownership or secure rights over agricultural land, disaggregated by sex. Land ownership is a legally recognised right to acquire, to use and to transfer land. “Secure rights” in the context of indicator 5.a.1 is defined as secure tenure rights, i.e., rights to use, manage and control land, fisheries and forests, in the sense of the Voluntary Guidelines on the Responsible Governance of Tenure of Land, Fisheries and Forests in the Context of National Food Security. Operationally, for the purposes of measurement of this indicator, secure tenure rights comprise both land ownership and two key alienation rights: the right to sell and the right to bequeath agricultural land."
                    },
                    {
                        label: "SDG 5.a.1.b: Share of women among owners or rights-bearers of agricultural land",
                        subtheme: "6.1.2 Mainstreaming gender equality, child protection, empowerment, and fairness",
                        item_code: ["24043"],
                        id: 3,
                        uid: 212,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Sub-indicator 5.a.1 (b) focuses on gender parity, measuring the extent to which women are disadvantaged in ownership or secure rights over agricultural land."
                    },
                    {
                        label: "SDG 5.a.2: Legal guarantees to women's equal rights to land ownership and/or control",
                        item_code: ["24026"],
                        id: 4,
                        uid: 213,
                        element_code: ["6204"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator 'measures' the level to which a country's legal framework supports women's land rights, by testing that framework against six proxies drawn from international law and internationally accepted good practices , in particular the Convention on the Elimination of Discrimination Against Women (CEDAW) ratified by 189 countries, and the Voluntary Guidelines for the Responsible Governance of the Tenure of Land Fisheries and Forestry (VGGT) endorsed unanimously by Committee of Food Security (CFS) members in 2012. Legend: 1 No evidence of guarantees of gender equality in the land ownership and/or control in the legal framework; 2 Very low levels of guarantees of gender equality in land ownership and/or control in the legal framework; 3 Low levels of guarantees of gender equality in land ownership and/or control in the legal framework; 4 Medium levels of guarantees of gender equality in land ownership and/or control in the legal framework; 5 High levels of guarantees of gender equality in land ownership and/or control in the legal framework; 6 Very high levels of guarantees of gender equality in land ownership and/or control in the legal framework."
                    },
                    {
                        label: "Degree of legal recognition of the right to food",
                        subtheme: "6.1.1 Rights of women, children, youth, indigenous groups and other vulnerable groups",
                        item_code: [],
                        id: 5,
                        uid: 214,
                        element_code: ["89844794"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Policies are classified based on the FAOLEX database five-group typology as: 1) Explicit protection of the right to food or directive of state policy. 2) Some other implicit recognition, codification of international statues, or other pertinent provisions. 3) None: countries with no policies catalogued in the FAOLEX database.",
                    },
                    {
                        label: "Holdings operated by civil persons, female",
                        item_code: ["270051"],
                        id: 6,
                        uid: 215,
                        element_code: ["60850"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wcad',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This item refers to the holdings operated by civil persons and managed by female holders in the household sector. This item is collected only from holdings in the household sector.",
                    },
                    {
                        label: "SDG 16.a.1: Existence of independent national human rights institutions in compliance with the Paris Principles",
                        subtheme: "6.1.1 Rights of women, children, youth, indigenous groups and other vulnerable groups",
                        item_code: ["SG_NHR_IMPLN"],
                        id: 7,
                        uid: 216,
                        element_code: ["16.a.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'status',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    // TODO: The view does not have a sex_code column, need to adjust the view
                    {
                        label: "SDG 5.4.1: Proportion of time spent on unpaid domestic and care work, by sex, age and location",
                        subtheme: "6.1.2 Mainstreaming gender equality, child protection, empowerment, and fairness",
                        item_code: ["SL_DOM_TSPD"],
                        id: 8,
                        uid: 217,
                        element_code: ["5.4.1"],
                        //sex_code: ["1", "2"],
                        //indicator_code: ["5.4.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        //chart_type: 'line', // Line can't be done here
                        chart_type: 'barChart',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "SDG 8.7.1: Child employment in agriculture",
                        subtheme: "6.1.1 Rights of women, children, youth, indigenous groups and other vulnerable groups",
                        item_code: ["1"],
                        id: 9,
                        uid: 218,
                        element_code: ["5-17", "5-11", "12-14"],
                        sex_code: ["SEX_T", "SEX_M", "SEX_F"],
                        indicator_code: ["8.7.1"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_ilo_sdg87',
                        area_code_is_string: true,
                        chart_type: 'barChart', // Line can't be done here                        
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                ]
            },
            {
                label: '6.2 Data and M&E',
                slug: 'data-and-m-e',
                items: [
                    {
                        label: "Statistical performance indicators",
                        subtheme: "6.2.1 Availability and quality of agrifood data, targets and indicators",
                        item_code: ["IQ.SPI.OVRL", "IQ.SPI.PIL1", "IQ.SPI.PIL2", "IQ.SPI.PIL3", "IQ.SPI.PIL4", "IQ.SPI.PIL5"],
                        id: 0,
                        uid: 219,
                        element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        highlightPrimarySeries: true,
                        description: "The SPI framework assesses the maturity and performance of national statistical systems in five key pillars: Data use (statistics have value only if they are used, emphasis on uptake and demand); Data services (platforms, documentation, and user services that connect producers and users); Data products (quality, relevance, timeliness, and accessibility of outputs. The products signal whether countries are able to produce indicators related to the 17 Sustainable Development Goals.); Data sources (strength and diversity of sources —censuses, surveys, administrative, new sources); Data infrastructure (institutions, governance, legal frameworks, standards, and financing).",
                    },
                    //   {
                    //     label: "Pillar 1 data use score",
                    //     item_code: ["IQ.SPI.PIL1"],
                    //     id: 1,
                    //     element_code: [],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_wdi',
                    //     chart_type: 'line',
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //   },
                    //   {
                    //     label: "Pillar 2 data services score",
                    //     item_code: ["IQ.SPI.PIL2"],
                    //     id: 2,
                    //     element_code: [],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_wdi',
                    //     chart_type: 'line',
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //   },
                    //   {
                    //     label: "Pillar 3 data products score",
                    //     item_code: ["IQ.SPI.PIL3"],
                    //     id: 3,
                    //     element_code: [],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_wdi',
                    //     chart_type: 'line',
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //   },
                    //   {
                    //     label: "Pillar 4 data sources score",
                    //     item_code: ["IQ.SPI.PIL4"],
                    //     id: 4,
                    //     element_code: [],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_wdi',
                    //     chart_type: 'line',
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //   },
                    //   {
                    //     label: "Pillar 5 data infrastructure score",
                    //     item_code: ["IQ.SPI.PIL5"],
                    //     id: 5,
                    //     element_code: [],
                    //     domain_code: 'fao-maps-review.fao_cca.mvw_wdi',
                    //     chart_type: 'line',
                    //     flag_sdg: 0,
                    //     trend_should: 'increase',
                    //     compare_with_id: [],
                    //   },
                ]
            },
            {
                label: '6.3 Governance',
                slug: 'governance',
                items: [
                    {
                        label: "Government effectiveness index",
                        subtheme: "6.3.4 Effectiveness of Policy Implementation",
                        element_code: ["GOV_WGI_GE"],
                        item_code: ["WGI_SC"],
                        id: 0,
                        uid: 220,
                        // element_code: [],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wgi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Government Effectiveness captures perceptions of the quality of public services, the quality of the civil service and the degree of its independence from political pressures, the quality of policy formulation and implementation, and the credibility of the government's commitment to such policies. Estimate gives the country's score on the aggregate indicator, in units of a standard normal distribution, i.e. ranging from approximately -2.5 to 2.5.",
                    },
                    {
                        label: "Civil society participation index",
                        subtheme: "6.3.1 Inclusiveness of cross-sectoral Consensus-Based Policy-Making ensuring LNOB",
                        item_code: [],
                        id: 1,
                        uid: 221,
                        unit: "Index (0-1)",
                        element_code: ["11204917"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fsd',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The core civil society index is designed to provide a measure of a robust civil society, understood as one that enjoys autonomy from the state and in which citizens freely and actively pursue their political and civic goals, however conceived.",
                    },
                    {
                        label: "Percent of firms choosing business licensing and permits as their biggest obstacle",
                        subtheme: "6.3.2 Creation of supportive regulatory framework",
                        id: 2,
                        uid: 222,
                        item_code: ["WB_ES_S_SECTOR_1"],
                        element_code: ["WB_ES_S_OBST3"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_es_obstacles',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Percentage of establishments that consider business licensing and permits to be the Biggest Obstacle.",
                    },
                    {
                        label: "SDG 17.14.1: Mechanisms in place to enhance policy coherence of sustainable development",
                        subtheme: "6.3.2 Creation of supportive regulatory framework",
                        item_code: ["SG_CPA_SDEVP"],
                        id: 3,
                        uid: 223,
                        element_code: ["17.14.1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    {
                        label: "SDG 16.10.2: Number of countries that adopt and implement constitutional, statutory and/ or policy guarantees for public access to information",
                        subtheme: "6.3.5. Accountability and Transparency in Agrifood Policymaking",
                        item_code: ["SG_INF_ACCSS"],
                        id: 4,
                        uid: 224,
                        element_code: ["16.10.2"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdg_full',
                        chart_type: 'status',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                    // TODO: Null values in the view
                    {
                        label: "Presence of a food system transformation pathway",
                        subtheme: "6.3.3 Awareness and use of the evidence-based / agrifood systems approach",
                        item_code: ["001"],
                        id: 5,
                        uid: 225,
                        element_code: ["001"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_fss',
                        area_code_is_string: true,
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                    },
                ]
            },
            {
                label: '6.4 Finance',
                slug: 'finance',
                items: [
                    {
                        label: "SDG 2.a.1: Agriculture share of government expenditures",
                        subtheme: "6.4.1 Scope and effectiveness of Government budgetary support",
                        item_code: ["2304"],
                        id: 0,
                        uid: 226,
                        element_code: ["6131"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ig',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator measures the share of total government expenditure allocated to the agriculture sector, including forestry, fishing and hunting. The indicator is also used in the calculation of the Agricultural Orientation Index (AOI), which compares the agriculture share of government expenditures to the agriculture share of GDP."
                    },
                    {
                        label: "SDG 2.a.1: Agriculture Orientation Index (AOI) for Government Expenditure",
                        subtheme: "6.4.1 Scope and effectiveness of Government budgetary support",
                        item_code: ["2304"],
                        id: 1,
                        uid: 227,
                        unit: "Index",
                        element_code: ["6197"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ig',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The Agriculture Orientation Index (AOI) for Government Expenditures is defined as the Agriculture Share of Government Expenditures, divided by the Agriculture Share of GDP, where Agriculture refers to the agriculture, forestry, fishing and hunting sector. The measure is a currency-free index, calculated as the ratio of these two shares."
                    },
                    {
                        label: "SDG 2.a.1: Agriculture value added share of GDP",
                        subtheme: "6.4.1 Scope and effectiveness of Government budgetary support",
                        item_code: ["24021"],
                        id: 2,
                        uid: 228,
                        element_code: ["6121"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_sdgb',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Agriculture, forestry, and fishing corresponds to ISIC (Rev. 4) divisions 01-03 and includes the exploitation of vegetal and animal natural resources, comprising the activities of growing of crops, raising and breeding of animals, harvesting of timber and other plants, animals or animal products from a farm or their natural habitats.Value added is the contribution to the economy by a producer or an industry or an institutional sector, which is estimated by the total value of output produced and deducting the total value of intermediate consumption of goods and services used to produce that output. This indicator is expressed as a percentage of Gross Domestic Product (GDP) which is the total income earned through the production of goods and services in an economic territory during an accounting period. Note: For VAB countries, gross value added at factor cost is used as the denominator.",
                    },
                    {
                        label: "Percent of firms choosing access to finance as their biggest obstacle",
                        subtheme: "6.4.2 Access to Finance and Investment Climate",
                        id: 3,
                        uid: 229,
                        element_code: ["WB_ES_S_OBST1"],
                        item_code: ["WB_ES_S_SECTOR_1"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_es_obstacles',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Percentage of establishments that consider access to finance to be the Biggest Obstacle",
                    },
                    {
                        label: "Account ownership at a financial institution or with a mobile-money-service provider (% of population ages 15+), total and by sex",
                        subtheme: "6.4.2 Access to Finance and Investment Climate",
                        item_code: ["FX.OWN.TOTL.ZS", "FX.OWN.TOTL.MA.ZS", "FX.OWN.TOTL.FE.ZS"],
                        id: 4,
                        uid: 230,
                        element_code: [''],
                        domain_code: 'fao-dwh-review.fao_cca.vw_wb_wdi',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "The percentage of respondents who report having an account (by themselves or together with someone else) at a bank or another type of financial institution (see the definition for \"financial institution account\") or report personally using a mobile money service in the past year (see the definition for \"mobile money account\"). (female/male (% age 15+) if it's by sex)",
                    },
                ]
            },
            {
                label: '6.5. Science and Innovation',
                slug: 'science-and-innovations',
                items: [
                    {
                        label: "Agriculture research spending",
                        item_code: ["23045"],
                        id: 0,
                        uid: 231,
                        element_code: ["6084", "6083"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_ae',
                        chart_type: 'multipleAxis',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Agricultural R&D is defined to include research on crops, livestock, forestry, fisheries, natural resources, as well as on-farm postharvest research.ASTI collects actual spending data, not budgeted or projected data, in thousands of current local currency units. If the financial year differs from the calendar year, spending is reported in the calendar year that covers the majority of the financial year in question."
                    },
                    {
                        label: "Households with access to agricultural production training or extension, share of total farm households (%)",
                        subtheme: "6.5.1 Agrifood education and advisory services",
                        indicator_code: ["ITC.H.ATE.PCT"],
                        id: 1,
                        uid: 232,
                        element_code: ["ITC"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_rulis',
                        chart_type: 'barChart',
                        flag_sdg: 0,
                        sex_code: ["N"],
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "This indicator measures the percentage of agricultural households that reported having access to agricultural production training or extension services over a defined reference period. It captures the reach of knowledge transfer efforts aimed at improving farming practices, productivity, and sustainability.",
                    },
                    {
                        label: "SDG 17.8.1: Individuals using the Internet (% of population)",
                        subtheme: "6.5.4 Digitalisation of agriculture",
                        item_code: ["11624"],
                        id: 2,
                        uid: 233,
                        element_code: ["i99H"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_itu',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "The indicator proportion of individuals using the Internet is defined as the proportion of individuals who used the Internet from any location in the last three months. The Internet is a worldwide public computer network.",
                    },
                    {
                        label: "SDG 5.b.1: Mobile (device) ownership (% of population)",
                        subtheme: "6.5.4 Digitalisation of agriculture",
                        item_code: [],
                        id: 3,
                        uid: 234,
                        unit: "%",
                        element_code: ["Q"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_gsma_mci',
                        chart_type: 'line',
                        flag_sdg: 1,
                        trend_should: 'increase',
                        compare_with_id: [],
                    }
                ]
            },
            {
                label: '6.6. Trade',
                slug: 'trade',
                items: [
                    {
                        label: "Total merchandise trade",
                        subtheme: "6.6.1 Trade profile",
                        item_code: ["10"],
                        id: 0,
                        uid: 235,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Total merchandise trade refers to the overall goods whose economic ownership is changed between a resident and a non-resident and that are not included in the following specific categories: goods under merchanting, non-monetary gold, and parts of travel, construction, and government goods and services n.i.e. It is the total of merchandise exports plus merchandise imports."
                    },
                    {
                        label: "Agricultural products trade",
                        subtheme: "6.6.1 Trade profile",
                        item_code: ["1882"],
                        id: 1,
                        uid: 236,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/>Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Cereals trade (quantities)",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1944"],
                        id: 2,
                        uid: 237,
                        element_code: ["5910", "5610"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export quantity is defined by the IMTS as the physical quantity of domestic origin or manufactured products shipped out of the country. It includes re-exports. According to the FAO methodology, the quantity of food and agricultural exports included in the FAOSTAT database is expressed in terms of weight (tonnes). As a general rule, trade quantity refers to net weight, excluding any sort of container.<br /><br />Import quantity represents the physical quantity of the products imported for domestic consumption or processing shipped into a country. It includes re-imports. According to the FAO methodology, the quantity of food and agricultural imports included in the FAOSTAT database is expressed in terms of weight (tonnes). As a general rule, trade quantity refers to net weight, excluding any sort of container. It includes also food aid quantities, where relevant."
                    },
                    {
                        label: "Cereals trade (value)",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1944"],
                        id: 3,
                        uid: 238,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br/> <br />Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Meat and meat preparations trade",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1885"],
                        id: 4,
                        uid: 239,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/>Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Fruit and vegetables trade",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1889"],
                        id: 5,
                        uid: 240,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/>Value of fruit and vegetables imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country).",
                    },
                    {
                        label: "Dairy products and eggs trade",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1886"],
                        id: 6,
                        uid: 241,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br />Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Beverages trade",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1895"],
                        id: 7,
                        uid: 242,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br />Value of beverages imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country).",
                    },
                    {
                        label: "Food excluding aquatic animal trade",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["1982"],
                        id: 8,
                        uid: 243,
                        element_code: ["5922", "5622"],
                        domain_code: 'fao-dwh-review.fao_cca.vw_tcl',
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/> Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Aquatic animal food trade (USD million)",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: [1, 2],
                        id: 9,
                        uid: 244,
                        element_code: [1, 1],
                        domain_code: 'fao-maps-review.fao_cca.mvw_fishstat_trade',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        exclude_subregional_comparison: true,
                        description: "Values of imports and exports of aquatic animal food (excluding algae) for human consumption grown in or harvested from water. It includes all types of fish, crustaceans, molluscs and other aquatic animals, with the exception of aquatic mammals and reptiles, which are excluded because their statistics are only available in individual catches (in numbers and not in weight)."
                    },
                    {
                        label: "Revealed Comparative Advantage (crops and livestock total)",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["515", "486", "44", "329", "560", "56", "403", "402", "490", "574", "489", "116", "162", "882", "27", "289", "83", "236", "267", "495", "388", "15"],
                        id: 10,
                        uid: 245,
                        unit: "Index",
                        element_code: ["509.02"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_tcli',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/> Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Export concentration index by commodity",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["515", "486", "44", "329", "560", "56", "403", "402", "490", "574", "489", "116", "162", "882", "27", "289", "83", "236", "267", "495", "388", "15"],
                        id: 11,
                        uid: 246,
                        unit: "Index (0-1)",
                        element_code: ["508"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_tcli',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/> Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Import concentration index by commodity",
                        subtheme: "6.6.2 Export performance and import dependency",
                        item_code: ["515", "486", "44", "329", "560", "56", "403", "402", "490", "574", "489", "116", "162", "882", "27", "289", "83", "236", "267", "495", "388", "15"],
                        id: 12,
                        uid: 247,
                        unit: "Index (0-1)",
                        element_code: ["507"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_tcli',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'increase',
                        compare_with_id: [],
                        description: "Export values are reported as FOB (free on board), that is, the value of the goods plus the value of the services performed to deliver the goods to the border of the exporting country). <br /> <br/> Value of agricultural imports are expressed in thousand US dollars in the FAOSTAT database. Import values are reported as CIF (Cost Insurance and Freight), that is, the value of the goods, plus the value of the services performed to deliver goods to the border of the exporting country, plus the value of the services performed to deliver the good from the border of the exporting country to the border of the importing country)."
                    },
                    {
                        label: "Percent of firms choosing customs and trade regulations as their biggest obstacle",
                        subtheme: "6.6.3 Market Access and Trade facilitation",
                        id: 13,
                        uid: 248,
                        // Forced here so the table reads the same whether or not the materialized view carries it.
                        unit: "Percent",
                        element_code: ["1"],
                        item_code: ["7"],
                        // The source splits the share into Manufacturing and Services: without picking both
                        // as series they land on one line, disagree in every year and nothing is drawn.
                        indicator_code: ["1", "2"],
                        domain_code: 'fao-maps-review.fao_cca.mvw_wb_es_obstacles',
                        area_code_is_string: true,
                        chart_type: 'line',
                        flag_sdg: 0,
                        trend_should: 'decrease',
                        compare_with_id: [],
                        description: "Percentage of establishments that consider customs and trade regulations to be the Biggest Obstacle.",
                    },
                ]
            }
        ]
    },
]
